import { E as subscribe, P as PUB_SUB_EVENTS, F as trackPackageFilterClicked, G as getProductByHandle, H as publish, C as getScriptTagJson, I as trackProductViewed, J as trackFlavorFilterClicked, K as trackSizeFilterClicked, L as trackMikMakClicked, M as getFlavorFilterInfo, D as isAboveLarge, B as formatShopifyPrice, A as firstMatchingParent, N as showLargeModal, O as getFlavorNameWithoutSize, y as trackProductCardViewed, Q as trapFocus, R as removeTrapFocus, S as trackQuestionStarted, T as trackReviewStarted, U as trackCartItemRemoved, V as trackCartItemQuantityChanged, W as fetchConfig, X as trackCartViewed, Y as showAlertDialog, Z as successToast, _ as trackCartItemSaveForLater, e as getStoredUTMParams, $ as API, a0 as getSelectedReward, a1 as trackCheckoutStarted, a2 as removeSelectedReward, a3 as saveSelectedReward, w as pluralize } from './app-chunk-common-BPZAsnhF.js';
import { s as showModalTerms, M as ModalAtcDisclaimer } from './app-chunk-modal-atc-disclaimer-Ch-oBYSE.js';
import { s as saveViewedProduct } from './app-chunk-utils-S2wKFyPJ.js';
import { t as topbar, p as placeholders } from './app-bundle.vendor.js';
import { a as getStockStatus, b as updateAvailabilityText, c as addToCartAndOpenCart, g as getProductData, d as getSizeFromVariantTitle, u as updateContentWithVariant, f as getVariantInfo, h as getVariantInfoWithProduct, e as ensureSwellLoaded } from './app-chunk-utils-4zL9DDjt.js';
import { a as addUserToList } from './app-chunk-widget-newsletter-Bm9KLVsd.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");

    if (!this.input) {
      throw new Error("Quantity input cannot find input");
    }

    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      // @ts-ignore
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  /**
   * @type {(()=> void) | undefined}
   */
  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();

    if (this.input.value === "0") {
      this.input.value = "1";
    }

    // We want the attribute to be in sync with the property value. Other areas cache html
    // so without this the qty will revert back to what it was on load.
    this.input.setAttribute("value", this.input.value.toString());
  }

  /**
   * @param {ButtonMouseEvent} event
   */
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    const cartItemIndex = this.getAttribute("cart-item-index");

    // When attempting to be a zero qty we remove it when used as cart item
    if (
      cartItemIndex !== null &&
      event.target.name === "minus" &&
      previousValue === this.input.value &&
      this.input.value === "1"
    ) {
      /** @type {import("./cart-drawer-items").CartDrawerItems} */
      // @ts-ignore
      const cartItems = this.closest("cart-drawer-items");
      cartItems.updateLineItem(Number(cartItemIndex), 0, 0, null);
      return;
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus?.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus?.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class SubscribeOptions extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("change", this.handleChange);
    this.syncMode();
    this.updateValue();
  }

  syncMode() {
    /** @type {import('./modal-atc-disclaimer').PurchaseTypeMode} */
    // @ts-ignore
    const mode = this.getAttribute("mode") || "onetime_default";

    if (mode === "onetime_default") {
      return;
    }

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const radio = this.querySelector("input[type=radio][value=subscription]");
    radio.checked = true;

    radio.dispatchEvent(new Event("change", { bubbles: true }));

    if (mode === "subscription_only") {
      radio.disabled = true;
      // @ts-ignore
      this.querySelector(".subs-ui__item").style.display = "none";

      this.querySelectorAll(".subs-ui__radio-wrapper").forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.display = "none";
        }
      });
    }
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.handleChange);
  }

  updateValue() {
    // @ts-ignore
    const value = this.querySelector("input[type=radio]:checked").value;

    if (value) {
      this.setAttribute("value", value);
    } else {
      this.removeAttribute("value");
    }
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.updateValue();

    if (!this.hasAttribute("show-terms")) {
      return;
    }

    if (event.target instanceof HTMLInputElement) {
      if (event.target.value === "subscription") {
        const discount = Number(this.getAttribute("discount"));
        showModalTerms(discount, () => {});
      }
    }
  }
}

customElements.define("subscribe-options", SubscribeOptions);

class ButtonGroup extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll("button");
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  connectedCallback() {
    this.buttons.forEach((btn) => {
      // @ts-ignore
      btn.addEventListener("click", this.onButtonClick);
    });
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => {
      // @ts-ignore
      btn.removeEventListener("click", this.onButtonClick);
    });
  }

  /**
   * @param {ButtonMouseEvent} event
   */
  onButtonClick(event) {
    const activeButton = Array.prototype.find.call(
      this.buttons,
      function (element) {
        return element.classList.contains("is-active");
      }
    );

    this.buttons.forEach((button) => button.classList.remove("is-active"));
    event.target.classList.add("is-active");

    const currentValue = activeButton ? activeButton.dataset.value : "";
    const value = event.target.dataset.value || "";

    if (currentValue === value) {
      return;
    }

    this.setAttribute("value", value);
    this.dispatchEvent(new CustomEvent("change", { detail: value }));
  }
}

customElements.define("button-group", ButtonGroup);

const productDataSelector = "#ProductJson-product-template";

/** @type {import("../types/products").Product | null} */
let productData = null;

class ProductInfo extends HTMLElement {
  constructor() {
    super();

    /** @type {import('./button-group').ButtonGroup|null} */
    this.productSize = this.querySelector("button-group.is-product-sizes");

    /** @type {import('./flavor-widget').FlavorWidget|null} */
    this.flavorWidget =
      this.querySelector("flavor-widget") ||
      this.querySelector("variant-widget") ||
      this.querySelector("variant-selector");

    /** @type {HTMLElement|null} */
    this.mikmakButton = this.querySelector(".mikmak-discover");

    /** @type {import('./subscribe-options').SubscribeOptions|null} */
    this.subscribeOptions = this.querySelector("subscribe-options");

    /** @type {import('./product-form').ProductForm} */
    // @ts-ignore
    this.productForm = this.querySelector("product-form");

    /** @type {import('./button-group').ButtonGroup|null} */
    this.deliverySchedule = this.querySelector(
      ".product-top__section.is-delivery-section button-group"
    );

    /** @type {import('./product-image-gallery').ProductImageGallery} */
    // @ts-ignore
    this.gallery = this.querySelector("product-image-gallery");

    /** @type {import('./product-atc-button').ProductATCButton} */
    // @ts-ignore
    this.productATCButton = this.querySelector("product-atc-button");

    /** @type {import('./back-in-stock').BackInStock | null} */
    this.backInStock = this.querySelector("back-in-stock");

    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleProductSizeChange = this.handleProductSizeChange.bind(this);
    this.handleDeliveryScheduleChange =
      this.handleDeliveryScheduleChange.bind(this);
    this.handleSubscribeOptionChange =
      this.handleSubscribeOptionChange.bind(this);
    this.handleGallerySlideChange = this.handleGallerySlideChange.bind(this);

    if (this.mikmakButton) {
      this.mikmakButton.addEventListener(
        "click",
        this.trackMikmakClicked.bind(this)
      );
    }

    this.trackVariantViewed();
  }

  connectedCallback() {
    this.flavorWidget?.addEventListener("change", this.handleVariantChange);
    // @ts-ignore
    this.productSize?.addEventListener("change", this.handleProductSizeChange);

    this.subscribeOptions?.addEventListener(
      "change",
      // @ts-ignore
      this.handleSubscribeOptionChange
    );

    this.deliverySchedule?.addEventListener(
      "change",
      this.handleDeliveryScheduleChange
    );

    // @ts-ignore
    this.gallery.addEventListener("change", this.handleGallerySlideChange);
    this.saveCurrentProductToRecentlyViewed();
  }

  saveCurrentProductToRecentlyViewed() {
    const [product, variant] = this.getSelectedVariantWithProduct();
    saveViewedProduct(product.id, variant.id, product.handle);
  }

  disconnectedCallback() {
    // @ts-ignore
    this.flavorWidget.removeEventListener("click", this.handleVariantChange);
    this.productSize?.removeEventListener(
      "change",
      // @ts-ignore
      this.handleProductSizeChange
    );

    this.subscribeOptions?.removeEventListener(
      "change",
      // @ts-ignore
      this.handleSubscribeOptionChange
    );

    this.deliverySchedule?.removeEventListener(
      "change",
      this.handleDeliveryScheduleChange
    );

    // @ts-ignore
    this.gallery.removeEventListener("change", this.handleGallerySlideChange);
  }

  /**
   * @param {CustomEvent} event
   */
  handleGallerySlideChange(event) {
    // For simple galleries it just switches images, there's no variant
    // to sync
    if (
      event.target instanceof HTMLElement &&
      event.target.hasAttribute("simple")
    ) {
      return;
    }
    this.flavorWidget?.setAttribute("value", event.detail.variantTitle);
    this.syncVariant();
  }

  /**
   * @param {CustomEvent} event
   */
  handleProductSizeChange(event) {
    if (event.detail === "linked") {
      const title = this.getAttribute("title") || "";
      // @ts-ignore
      const handle = event.target.querySelector("[data-value='linked']").dataset
        .linkedPdp;
      trackPackageFilterClicked(title, "LinkedPDP");
      this.redirectToLinkedPDP(handle);
      return;
    }
    this.flavorWidget?.setAttribute("size", event.detail);
  }

  /**
   * @param {string} handle
   */
  async redirectToLinkedPDP(handle) {
    topbar.show();
    const product = await getProductByHandle(handle);
    const variantTitle = this.flavorWidget?.getAttribute("value") || "";
    const relatedVariant = product.variants.find(
      // @ts-ignore
      (x) => x.title === variantTitle
    );
    const url = relatedVariant
      ? `${product.url}?variant=${relatedVariant.id}`
      : product.url;

    window.location = url;
  }

  handleVariantChange() {
    this.syncVariant();
    this.trackVariantChanged();
    this.saveCurrentProductToRecentlyViewed();
  }

  handleDeliveryScheduleChange() {
    this.syncVariant();
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleSubscribeOptionChange(event) {
    if (event.target instanceof HTMLInputElement) {
      this.setAttribute("schedule", event.target.value);
    }
    this.syncVariant();
  }

  /**
   * @returns {[import("../types/products").Product, import("../types/products").ProductVariant]}
   */
  getSelectedVariantWithProduct() {
    const product = this.getProduct();

    /** @type {import("../types/products").ProductVariant|null} */
    let variant = product.variants[0];

    if (this.flavorWidget) {
      const flavor = this.flavorWidget.getAttribute("value") || "";
      variant = product.variants.find((x) => x.title === flavor) || null;
    }

    if (!variant) {
      throw new Error("ProductVariant is null in PDP");
    }

    return [product, variant];
  }

  syncVariant() {
    const [_product, variant] = this.getSelectedVariantWithProduct();
    const purchaseType = this.getAttribute("schedule") || "";

    /** @type {HTMLInputElement|null} */
    const sellingPlanInput = this.productForm.querySelector(
      "input[name='selling_plan']"
    );

    if (!variant) {
      throw new Error("ProductVariant is null when trying to update pricing");
    }

    this.productATCButton.setVariant(variant, purchaseType);

    // @ts-ignore
    this.productForm.querySelector("input[name='id']").value =
      variant.id.toString();

    if (sellingPlanInput) {
      const planId = this.getCurrentPlan(variant);
      sellingPlanInput.value = String(planId || "");
    }

    const base = window.location.pathname.split("?")[0];
    const url = base + "?variant=" + variant.id;
    console.log("URL", url);
    window.history.pushState({}, "", url);

    this.gallery?.setAttribute("value", String(variant.id));

    // const comingSoon = isComingSoon(this, variant.id);

    const stockStatus = getStockStatus(this, variant.title);
    this.setAttribute("stock-status", stockStatus);
    this.backInStock?.setAttribute("mode", stockStatus);
    this.backInStock?.setAttribute("variant-id", String(variant.id));
    this.productATCButton.setAttribute("stock-status", stockStatus);

    this.backInStock?.setAttribute("variant-id", String(variant.id));
    updateAvailabilityText(this, variant);

    publish(PUB_SUB_EVENTS.pdpVariantChange, {
      variantId: variant.id,
    });
  }

  /**
   * @returns {"onetime"|"subscription"}
   */
  getDeliverySchedule() {
    if (this.deliverySchedule === null) {
      return "onetime";
    }
    // @ts-ignore
    return this.deliverySchedule.getAttribute("value") || "";
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   * @returns {number|null}
   */
  getCurrentPlan(variant) {
    const purchaseType = this.getAttribute("schedule") || "";

    if (purchaseType === "onetime") {
      return null;
    }

    const product = this.getProduct();
    const schedule = this.getDeliverySchedule();

    if (
      !product.selling_plan_groups ||
      product.selling_plan_groups.length === 0
    ) {
      throw new Error("We expecte selling plan groups for subscription types");
    }

    let index = -1;
    let plans = product.selling_plan_groups[0].selling_plans;

    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];

      if (plan.name === schedule) {
        index = i;
        break;
      }
    }

    return variant.selling_plan_allocations[index].selling_plan_id;
  }

  /**
   * @returns {import("../types/products").Product}
   */
  getProduct() {
    if (productData === null) {
      // @ts-ignore
      productData = getScriptTagJson(productDataSelector, this);
    }

    if (!productData) {
      throw new Error(
        "getProduct() returns null inside product-info component"
      );
    }
    return productData;
  }

  trackVariantViewed() {
    const [product, variant] = this.getSelectedVariantWithProduct();
    trackProductViewed(product, variant.id, "pdp", "variant-widget");
  }

  trackVariantChanged() {
    const [product, variant] = this.getSelectedVariantWithProduct();

    if (product.options.length > 0) {
      if (product.options[0].toUpperCase() === "FLAVOR") {
        trackFlavorFilterClicked(product.title, variant.title);
      } else {
        trackSizeFilterClicked(product.title, variant.title);
      }
    }
    trackProductViewed(product, variant.id, "pdp", "top-area");
  }

  trackMikmakClicked() {
    const [product, variant] = this.getSelectedVariantWithProduct();
    const schedule = this.getAttribute("schedule");

    // @ts-ignore
    const qty = this.querySelector("input[name='quantity']").value;

    let isRecurring = false;
    let frequency = "";

    if (schedule === "subscription") {
      const deliveryScheduleText = this.getDeliverySchedule();
      isRecurring = true;
      frequency = (deliveryScheduleText.match(/\d+/) || [])[0] || "";
    }

    trackMikMakClicked(
      qty,
      variant.id,
      product,
      "pdp",
      "pdp",
      isRecurring,
      frequency
    );
  }
}

customElements.define("product-info", ProductInfo);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLFormElement|null} */
    this.form = this.querySelector("form");

    /** @type {import('./product-atc-button').ProductATCButton} */
    // @ts-ignore
    this.productATCButton =
      this.querySelector("pdp-atc-button") ||
      this.querySelector("product-atc-button") ||
      this.querySelector(".product-form__submit-btn");

    const pdpMain = this.closest("pdp-main");

    /** @type {import('./product-atc-button').ProductATCButton|null} */
    this.stickyATCButton = null;

    if (pdpMain) {
      this.stickyATCButton = pdpMain.querySelector("pdp-sticky pdp-atc-button");
    }

    /** @type {import("./cart-drawer").CartDrawer} */
    // @ts-ignore
    this.cart = document.querySelector("cart-drawer");

    if (this.form) {
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
  }

  /**
   * @param {SubmitEvent} event
   */
  onSubmitHandler(event) {
    if (!this.form) {
      return;
    }

    event.preventDefault();

    if (this.productATCButton.hasAttribute("loading")) {
      return;
    }

    this.productATCButton.setAttribute("loading", "");
    this.stickyATCButton?.setAttribute("loading", "");

    const formData = new FormData(this.form);

    /** @type {HTMLElement} */
    const trackingElement =
      this.closest("product-info") ||
      this.closest("[data-product-scope]") ||
      this;

    const variantId = Number(formData.get("id"));
    const quantity = Number(formData.get("quantity"));
    const sellingPlanId = formData.get("selling_plan");

    addToCartAndOpenCart(
      variantId,
      quantity,
      sellingPlanId ? Number(sellingPlanId) : null,
      trackingElement,
      event.submitter
    ).then(() => {
      this.productATCButton.removeAttribute("loading");
      this.stickyATCButton?.removeAttribute("loading");
    });
  }
}

customElements.define("product-form", ProductForm);

class ProductImageGallery extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLImageElement} */
    // @ts-ignore
    this.mainImage = this.querySelector(".pdp-gallery__slide img");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.container = this.querySelector(".pdp-gallery");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.slides = this.querySelector(".pdp-gallery__slides");

    /** @type {NodeListOf<HTMLElement>} */
    this.thumbs = this.querySelectorAll(".pdp-gallery__thumb");

    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onClickThumb = this.onClickThumb.bind(this);

    this.mainImage.addEventListener("load", this.onImageLoaded, false);
  }

  static get observedAttributes() {
    return ["value"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "value" && oldValue !== newValue) {
      this.selectSlideByVariantId(newValue);
    }
  }

  connectedCallback() {
    this.setIndex(0, false);
    this.enableSwiping();

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onClickThumb);
    });
  }

  disconnectCallback() {
    this.thumbs.forEach((thumb) => {
      thumb.removeEventListener("click", this.onClickThumb);
    });
  }

  /**
   * @param {MouseEvent} event
   */
  onClickThumb(event) {
    if (event.target instanceof HTMLElement) {
      const index = Number(event.target.dataset.slideIndex);
      this.setIndex(index);
    }
  }

  onImageLoaded() {
    this.mainImage.removeEventListener("load", this.onImageLoaded);
    this.mainImage.classList.add("is-ready");
  }

  /**
   * @param {string} variantId
   */
  selectSlideByVariantId(variantId) {
    this.displayRelatedThumbs();
    for (const thumb of this.thumbs) {
      if (thumb.dataset.slideVariantId === variantId) {
        const index = Number(thumb.dataset.slideIndex);
        this.setIndex(index, true, false);
        break;
      }
    }
  }

  displayRelatedThumbs() {
    const currentVariantId = this.getAttribute("value") || "";
    let matchingThumb = null;
    for (const thumb of this.thumbs) {
      if (thumb.dataset.slideVariantId === currentVariantId) {
        matchingThumb = thumb;
        break;
      }
    }

    if (!matchingThumb) {
      return;
    }

    const variantTitle = matchingThumb.dataset.slideVariantTitle || "";
    const info = getFlavorFilterInfo(variantTitle);

    for (const thumb of this.thumbs) {
      const thumbInfo = getFlavorFilterInfo(
        thumb.dataset.slideVariantTitle || ""
      );
      if (thumbInfo.size === info.size) {
        thumb.style.display = "";
      } else {
        thumb.style.display = "none";
      }
    }
  }

  getSlideCount() {
    return this.thumbs.length;
  }

  /**
   * @returns {HTMLElement}
   * */
  getActiveThumb() {
    for (const thumb of this.thumbs) {
      if (thumb.classList.contains("is-active")) {
        return thumb;
      }
    }
    throw new Error("No active slide thumnail found");
  }

  getActiveIndex() {
    const activeThumb = this.getActiveThumb();
    return Number(activeThumb.dataset.slideIndex);
  }

  /**
   * @param {number} index
   * @param {boolean} [forceScroll]
   * @param {boolean} [triggerChange]
   */
  setIndex(index, forceScroll = true, triggerChange = true) {
    // No other images
    if (this.thumbs.length === 0) {
      this.mainImage.classList.add("is-ready");
      return;
    }

    /** @type {HTMLImageElement} */
    // @ts-ignore
    const selectedThumb = this.thumbs[index];

    /** @type {HTMLImageElement} */
    // @ts-ignore
    const selectedThumbImg = this.thumbs[index].querySelector("img");

    if (
      triggerChange === true &&
      selectedThumb.classList.contains("is-active")
    ) {
      return;
    }

    this.thumbs.forEach((thumb) => {
      thumb.classList.remove("is-active");
    });

    selectedThumb.classList.add("is-active");
    const src = selectedThumbImg.src || selectedThumbImg.dataset.src;

    if (src) {
      this.mainImage.style.transition = "none";
      this.mainImage.classList.remove("is-ready");

      this.mainImage.src = src;
      this.mainImage.alt = selectedThumbImg.alt;

      window.setTimeout(() => {
        this.mainImage.style.transition = "";
        this.mainImage.classList.add("is-ready");
      }, 30);
    }

    if (triggerChange) {
      this.triggerChangeEvent();
    }

    if (isAboveLarge() && forceScroll === true) {
      if ("scrollIntoView" in selectedThumb) {
        selectedThumb.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }
  }

  triggerChangeEvent() {
    const activeThumb = this.getActiveThumb();
    const variantTitle = activeThumb.dataset.slideVariantTitle;
    const variantId = activeThumb.dataset.slideVariantId;
    const data = {
      variantTitle: variantTitle,
      variantId: variantId,
    };
    const event = new CustomEvent("change", { detail: data });
    this.dispatchEvent(event);
  }

  enableSwiping() {
    // @ts-ignore
    const hammertime = new window.Hammer(this.slides);

    hammertime.on("swiperight", () => {
      const maxIndex = this.getSlideCount() - 1;
      const currentIndex = this.getActiveIndex();
      let newIndex = currentIndex - 1 < 0 ? maxIndex : currentIndex - 1;
      this.setIndex(newIndex);
    });

    hammertime.on("swipeleft", () => {
      const maxIndex = this.getSlideCount() - 1;
      const currentIndex = this.getActiveIndex();
      let newIndex = currentIndex + 1 > maxIndex ? 0 : currentIndex + 1;
      this.setIndex(newIndex);
    });

    this.container.classList.add("is-loaded");
  }
}

customElements.define("product-image-gallery", ProductImageGallery);

const addToCartText = "Add to Cart";
const addToBoxText = "Add to Box";

class ProductATCButton extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.button =
      this.querySelector(".quick-add-btn") ||
      this.querySelector(".product-form__submit-btn");

    if (!this.button) {
      throw new Error("Could not find button to add ATC to");
    }

    this.button.addEventListener("click", this.handleCilckATCButton.bind(this));
  }

  static get observedAttributes() {
    return ["loading"];
  }

  /**
   * @param {string} name
   */
  attributeChangedCallback(name) {
    if (name === "loading") {
      this.updateLoadingStatus();
    }
  }

  updateLoadingStatus() {
    if (this.hasAttribute("loading")) {
      this.button.classList.add("is-loading");
      this.button.setAttribute("aria-disabled", "true");
      this.button.dataset.state = "submitting";
    } else {
      this.button.classList.remove("is-loading");
      this.button.removeAttribute("aria-disabled");
      this.button.dataset.state = "idle";
    }
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   * @param {string} purchaseType
   * */
  setVariant(variant, purchaseType) {
    // TODO: Set sold out info
    this.updateButtonText(variant, purchaseType);
  }

  /**
   * @param {import("../types/products").ProductVariant} variant
   * @param {string} purchaseType
   * */
  updateButtonText(variant, purchaseType) {
    // Dont update butotn text if not dynamic
    if (this.button.classList.contains("is-dynamic") === false) {
      return;
    }

    let text = addToCartText;
    const textEl = this.button.querySelector(".button__text");

    if (
      purchaseType !== "onetime" &&
      variant.selling_plan_allocations.length > 0
    ) {
      const salePrice = variant.selling_plan_allocations[0].price;
      const f = formatShopifyPrice;
      text =
        `${addToBoxText} ` +
        `<span class="is-compare-price">${f(variant.price)}</span>` +
        `<span class="is-separator"> | </span>` +
        `<span class="is-sale-price">${f(salePrice)}</span>`;
    } else {
      text = addToCartText + " " + formatShopifyPrice(variant.price);
    }

    // @ts-ignore
    textEl.innerHTML = text;
  }

  /**
   * @param {Event} e
   */
  handleCilckATCButton(e) {
    if (!this.querySelector("[data-disclaimer-anchor]")) {
      console.log("No anchor");
      return;
    }

    const product = getProductData(this);

    console.log(product);
    if (product.selling_plan_groups.length === 0) {
      return;
    }

    e.preventDefault();

    const variantId = Number(
      // @ts-ignore
      this.closest("product-form").querySelector("input[name='id']").value
    );

    // @ts-ignore
    const qty = Number(this.querySelector("input[name='quantity']").value);
    const variant = product.variants.find((x) => x.id === variantId);
    console.log("Variant", variant);
    console.log("VarID", variantId);
    console.log("Qty", qty);
    // @ts-ignore
    ModalAtcDisclaimer.show(this, product, variant, qty);
  }
}

customElements.define("product-atc-button", ProductATCButton);

class ProductFacts extends HTMLElement {
  /**
   * @type {(()=> void) | undefined}
   */
  pdpVariantUnsubscriber = undefined;

  constructor() {
    super();

    this.headers = this.querySelectorAll(".pdp-facts__item-header");
    this.onClickHeader = this.onClickHeader.bind(this);
  }

  connectedCallback() {
    this.headers.forEach((header) => {
      header.addEventListener("click", this.onClickHeader);
    });

    this.pdpVariantUnsubscriber = subscribe(
      PUB_SUB_EVENTS.pdpVariantChange,
      (event) => {
        this.updateVariantFacts(event.variantId);
      }
    );
  }

  disconnectedCallback() {
    this.headers.forEach((header) => {
      header.removeEventListener("click", this.onClickHeader);
    });

    if (this.pdpVariantUnsubscriber) {
      this.pdpVariantUnsubscriber();
    }
  }

  /**
   * @param {Event} event
   */
  onClickHeader(event) {
    if (event.target instanceof HTMLElement) {
      /** @type {HTMLElement} */
      // @ts-ignore
      const item = firstMatchingParent(event.target, ".pdp-facts__item");

      /** @type {HTMLElement} */
      // @ts-ignore
      const body = item.querySelector(".pdp-facts__item-body");

      if (item.classList.contains("is-open")) {
        $(body).fadeOut();
        item.classList.remove("is-open");
      } else {
        $(body).fadeIn();
        item.classList.add("is-open");
      }
    }
  }

  /**
   * @param {Number} activeVariantId
   */
  updateVariantFacts(activeVariantId) {
    const elements = this.querySelectorAll("[data-only-for-variant]");
    for (const el of elements) {
      const variantId = Number(el.getAttribute("data-only-for-variant"));
      el.classList.toggle("is-visible", activeVariantId === variantId);
    }
  }
}

customElements.define("product-facts", ProductFacts);

const reviewsHTML = `
  <div id="cardProductReviews" class="card-product__reviews nuun-yotpo-container">
    <h2 class="card-product__reviews-title">{{productName}} Reviews</h2>
    <div class="yotpo-widget-instance"
         data-yotpo-instance-id="786905"
         data-yotpo-product-id="{{productId}}"
         data-yotpo-name="{{productName}}"></div>
    <div class="card-product__reviews-loading">
      Loading...
    </div>
`;

class ProductReviewsModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick);
  }

  handleClick() {
    const productId = this.getAttribute("product-id");
    const productName = this.getAttribute("product-name");
    const data = { productId, productName };
    const templateId = "cardProductReviews";

    if (!document.getElementById(templateId)) {
      const script = document.createElement("script");
      script.id = templateId;
      script.type = "text/x-template";
      script.innerHTML = reviewsHTML;
      document.body.appendChild(script);
    }

    showLargeModal(data, `#${templateId}`, null, { buttonText: "Close" });

    // @ts-ignore
    yotpoWidgetsContainer.initWidgets(false);
  }
}

customElements.define("product-reviews-modal", ProductReviewsModal);

class VariantWidget extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-ignore
    this.selectedItem = this.querySelector(
      ".variant-widget__ui-selected-inner"
    );

    /** @type {HTMLElement} */
    // @ts-ignore
    this.emptyView = this.querySelector(
      ".variant-widget__ui-content-item-empty"
    );

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.triggerButton = this.querySelector(".variant-widget__ui-selected");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.listbox = this.querySelector(".variant-widget__ui-content-list");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.handleKeydownEvent = this.handleKeydownEvent.bind(this);
    this.handleKeydownOutsideEvent = this.handleKeydownOutsideEvent.bind(this);

    this.handleKeydownEvent = this.handleKeydownEvent.bind(this);
    this.handleClickOutsideEvent = this.handleClickOutsideEvent.bind(this);

    this.addEventListener("keydown", this.handleKeydownEvent);

    /** @type {HTMLElement|null} */
    this.activeElement = null;
  }

  static get observedAttributes() {
    return ["value", "size"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "value" && oldValue !== newValue) {
      this.selectItemByTitle(newValue);
    }
  }

  connectedCallback() {
    this.ctrl = new AbortController();
    this.addEventListener("keydown", this.handleKeydownEvent, {
      signal: this.ctrl.signal,
    });
    this.addEventListener("click", this.handleClickEvent, {
      signal: this.ctrl.signal,
    });
  }

  disconnectedCallback() {
    if (this.ctrl) {
      this.ctrl.abort();
    }
  }

  open() {
    this.filterMatchingListItems();
    this.classList.add("is-open");
    this.listbox.inert = false;
    this.triggerButton.setAttribute("aria-expanded", "true");
    document.addEventListener("keydown", this.handleKeydownOutsideEvent);
    document.addEventListener("click", this.handleClickOutsideEvent);

    const items = this.getVisibleItems();
    if (items.length > 0) {
      this.selectItemFromKeyboard(items[0]);
    }
  }

  close() {
    this.classList.remove("is-open");
    document.removeEventListener("keydown", this.handleKeydownOutsideEvent);
    document.removeEventListener("click", this.handleClickOutsideEvent);
    this.triggerButton.setAttribute("aria-expanded", "false");
    this.listbox.inert = true;

    if (this.activeElement) {
      window.setTimeout(() => {
        this.triggerButton.focus();
        this.activeElement = null;
      });
    }
  }

  /** @returns {HTMLElement[]} */
  getVisibleItems() {
    // @ts-ignore
    return [...this.listbox.querySelectorAll("[role=option]")].filter(
      // @ts-expect-error
      (el) => el.style.display !== "none"
    );
  }

  /** @param {HTMLElement} item */
  selectItemFromKeyboard(item) {
    this.listbox
      .querySelectorAll("li")
      .forEach((el) => el.classList.remove("is-active"));

    item.focus();
    this.activeElement = item;
    this.activeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  filterMatchingListItems() {
    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".variant-widget__ui-content-item");
    const value = this.getAttribute("value") || "";
    const size = this.getAttribute("size") || null;

    let activeCount = 0;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const itemSize = items[i].dataset.size;

      // The selected item should not be displayed
      if (item.dataset.value === value) {
        item.style.display = "none";
        continue;
      }

      // If no size then item allowed
      if (!size) {
        activeCount++;
        item.style.display = "";
        continue;
      }

      if (size === itemSize) {
        activeCount++;
        item.style.display = "";
        continue;
      }

      item.style.display = "none";
    }

    this.emptyView.style.display = activeCount === 0 ? "" : "none";
  }

  /**
   * @param {MouseEvent} event
   */
  handleClickEvent(event) {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (event.target.matches(".variant-widget__ui-content-item")) {
      this.selectItem(event.target);
      return;
    }

    event.stopPropagation();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * @param {KeyboardEvent} event
   * */
  handleKeydownEvent(event) {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    const target = event.target;
    const key = event.key;

    // Ignore so document handler can handle it
    if (key === "Escape" || key === "esc") {
      return;
    }

    if (target === this.triggerButton) {
      this.onTriggerButtonKeydown(key, event);
      return;
    }

    if (target.matches("[role=option]")) {
      this.onOptionKeydown(key, event);
      return;
    }
  }

  /**
   * @param {string} key
   * @param {KeyboardEvent} event
   */
  onTriggerButtonKeydown(key, event) {
    if (this.isOpen() === false && (key === " " || key === "Enter")) {
      this.activeElement = this.triggerButton;
      this.open();
      event.preventDefault();
      event.stopPropagation();
    }
  }
  /**
   * @param {string} key
   * @param {KeyboardEvent} event
   */
  onOptionKeydown(key, event) {
    let handled = false;

    switch (key) {
      case "ArrowDown":
        this.selectNextItem();
        handled = true;
        break;
      case "ArrowUp":
        this.selectPreviousItem();
        handled = true;
        break;
      case "Tab":
        this.close();
        handled = true;
      case "Enter":
        this.close();
        /** @type {HTMLElement} */
        // @ts-expect-error
        const target = event.target;
        this.selectItem(target);
        handled = true;
        break;
    }

    if (handled) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  selectPreviousItem() {
    const items = this.getVisibleItems();
    let prevIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        prevIndex = i - 1;
        break;
      }
    }

    if (items[prevIndex]) {
      this.activeElement = items[prevIndex];
      this.activeElement.focus();
    }
  }

  selectNextItem() {
    const items = this.getVisibleItems();
    let nextIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        nextIndex = i + 1;
        break;
      }
    }

    if (items[nextIndex]) {
      this.activeElement = items[nextIndex];
      this.activeElement.focus();
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydownOutsideEvent(event) {
    if (event.key === "Escape" || event.key === "esc") {
      this.closeAll();
    }
  }

  handleClickOutsideEvent() {
    this.close();
  }

  isOpen() {
    return this.classList.contains("is-open");
  }

  closeAll() {
    document
      .querySelectorAll("variant-widget")
      // @ts-ignore
      .forEach((/** @type {FlavorWidget} */ el) => {
        el.close();
      });
  }

  /**
   * @param {string} title
   */
  selectItemByTitle(title) {
    const items = this.querySelectorAll(".variant-widget__ui-content-item");

    for (const item of items) {
      if (item instanceof HTMLElement) {
        if (item.dataset.value === title) {
          this.selectItem(item);
          break;
        }
      }
    }
  }

  /**
   * @param {HTMLElement} previewItem
   * @param {HTMLElement} selectedItem
   */
  updateSelectedItemPreview(previewItem, selectedItem) {
    /** @type {HTMLElement|null} */
    const previewCircle = previewItem.querySelector(
      ".variant-widget__ui-flavor-circle"
    );

    /** @type {HTMLElement|null} */
    const circleEl = selectedItem.querySelector(
      ".variant-widget__ui-flavor-circle"
    );

    /** @type {HTMLElement} */
    // @ts-ignore
    const titleEl = previewItem.querySelector(
      ".variant-widget__ui-flavor-title"
    );

    if (circleEl && previewCircle) {
      previewCircle.dataset.variant = circleEl.dataset.variant;
      previewCircle.dataset.shortVariant = circleEl.dataset.variant;
    }

    const previewImg = previewItem.querySelector("img");
    const img = selectedItem.querySelector("img");

    if (previewImg && img) {
      previewImg.src = img.src;
      previewImg.alt = img.alt;
    }

    titleEl.textContent = getFlavorNameWithoutSize(
      selectedItem.dataset.value || ""
    );
  }

  /**
   * @param {HTMLElement} item
   */
  selectItem(item) {
    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".flavor-widget__item");
    const flavor = item.dataset.value || "";

    const needsTrigger = flavor !== this.getAttribute("value");

    items.forEach((el) => {
      if (el.dataset.value === flavor) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });

    this.setAttribute("value", flavor);

    /** @type {HTMLElement} */
    // @ts-ignore
    const selectedEl = this.querySelector(".variant-widget__ui-selected");

    this.updateSelectedItemPreview(selectedEl, item);

    if (needsTrigger) {
      const event = new CustomEvent("change", { detail: flavor });
      this.dispatchEvent(event);
    }

    if (this.activeElement) {
      this.triggerButton.focus();
    }
  }
}

customElements.define("variant-widget", VariantWidget);

class CardProduct extends HTMLElement {
  constructor() {
    super();
    /** @type {import('./variant-widget.js').VariantWidget|null}*/
    this.variantWidget = this.querySelector("variant-widget");

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.buyNowButton = this.querySelector(".card-product__buy-now");

    /** @type {HTMLButtonElement|null} */
    this.cartProductSizes = this.querySelector("card-product-sizes");

    this.handleInView = this.handleInView.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleClickBuyNow = this.handleClickBuyNow.bind(this);
    this.handleSizechange = this.handleSizechange.bind(this);
  }

  connectedCallback() {
    if (this.variantWidget) {
      // @ts-ignore
      this.variantWidget.addEventListener("change", this.handleVariantChange);
    }
    this.buyNowButton.addEventListener("click", this.handleClickBuyNow);

    if (!this.id) {
      console.error("Card product requires an id", this);
    }

    // @ts-ignore
    this.addEventListener("size-change", this.handleSizechange);
    this.addEventListener("in-view", this.handleInView);
  }

  disconnectedCallback() {
    if (this.variantWidget) {
      this.variantWidget.removeEventListener(
        "change",
        // @ts-ignore
        this.handleVariantChange
      );
    }
    this.buyNowButton.removeEventListener("click", this.handleClickBuyNow);
    // @ts-ignore
    this.removeEventListener("size-change", this.handleSizechange);
    this.removeEventListener("in-view", this.handleInView);
  }

  /**
   * @returns {[import("../types/products").Product, import("../types/products").ProductVariant]}
   */
  getSelectedProductData() {
    const product = getProductData(this);
    let variant = null;
    const size = this.cartProductSizes?.getAttribute("value");

    let firstMatchingSize = null;

    if (this.variantWidget) {
      const title = this.variantWidget.getAttribute("value");
      const shortName = getFlavorNameWithoutSize(title);

      variant = product.variants.find((x) => {
        const variantSize = getSizeFromVariantTitle(product.title, x.title);
        const variantShortName = getFlavorNameWithoutSize(x.title);

        if (size && size === variantSize) {
          firstMatchingSize = x;
        }

        if (size && shortName === variantShortName && size === variantSize) {
          return x;
        }

        if (!size && title === x.title) {
          return x;
        }
        return false;
      });
    } else {
      variant = product.variants[0];
    }

    // If we don't have a size we expect a matching variant
    if (!size && !variant) {
      throw new Error("[card-product:buy-new:click] No variant found");
    }

    // When no matching variant found
    if (!variant) {
      variant = firstMatchingSize || product.variants[0];
    }

    return [product, variant];
  }

  handleSizechange() {
    const [_product, variant] = this.getSelectedProductData();
    const size = this.cartProductSizes?.getAttribute("value") || "";
    this.variantWidget?.setAttribute("value", variant.title);
    this.variantWidget?.setAttribute("size", size);
    this.updateCardContent();
  }

  handleClickBuyNow() {
    const [product, variant] = this.getSelectedProductData();

    // @ts-ignore
    const qty = this.querySelector("input[name=quantity]").valueAsNumber;

    if (product.selling_plan_groups.length === 0) {
      addToCartAndOpenCart(variant.id, qty, null, this);
      return;
    }

    /** @type {import('./modal-atc-disclaimer').PurchaseTypeMode} */
    // @ts-ignore
    const disclaimerModalMode = this.getAttribute("modal-mode") || "onetime";
    ModalAtcDisclaimer.show(this, product, variant, qty, disclaimerModalMode);
  }

  handleVariantChange() {
    this.updateCardContent();
  }

  updateCardContent() {
    const variantTitle = this.variantWidget?.getAttribute("value") || "";
    const status = getStockStatus(this, variantTitle);
    this.setAttribute("mode", status);
    updateContentWithVariant(this, variantTitle, true);
  }

  handleInView() {
    const product = getProductData(this);
    const variantTitle = this.variantWidget?.getAttribute("value");
    const variant = variantTitle
      ? product.variants.find((x) => x.title === variantTitle)
      : product.variants[0];

    if (!variant) {
      console.error("Could not find variant for product card event", this);
      return;
    }

    const category = this.getAttribute("category") || "";
    const source = this.getAttribute("source") || "";
    trackProductCardViewed(product, variant.id, category, source);
  }
}

customElements.define("card-product", CardProduct);

class CardProductSizes extends HTMLElement {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.buttons = this.querySelectorAll("button");
  }

  connectedCallback() {
    this.buttons.forEach((btn) => {
      btn.addEventListener("click", this.handleButtonClick);
    });

    /** @type {HTMLButtonElement|null} */
    const selected = this.querySelector("button.is-selected");

    if (selected) {
      this.setAttribute("value", selected.dataset.size || "");
    }
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => {
      btn.removeEventListener("click", this.handleButtonClick);
    });
  }

  /**
   * @param {MouseEvent} e
   */
  handleButtonClick(e) {
    /** @type {HTMLButtonElement} */
    // @ts-ignore
    const target = e.currentTarget;
    const newSize = target.dataset.size || "";
    const currentSize = this.getAttribute("size") || "";

    if (newSize === currentSize) {
      return;
    }

    this.buttons.forEach((btn) => {
      btn.classList.toggle("is-selected", btn.dataset.size === newSize);
    });

    this.setAttribute("value", newSize);
    this.dispatchEvent(
      new CustomEvent("size-change", {
        detail: newSize,
        bubbles: true,
      })
    );
  }
}

customElements.define("card-product-sizes", CardProductSizes);

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.button = this.querySelector(".quick-add-btn");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.container = this.querySelector(".quick-add");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.innerContainer = this.querySelector(".quick-add__container");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.closeButton = this.querySelector(".quick-add__close");

    this.onClick = this.onClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);

    this.button.addEventListener("click", this.onClick.bind(this));
    this.closeButton.addEventListener("click", this.onCloseClick.bind(this));
  }

  static get observedAttributes() {
    return ["open"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open" && oldValue !== newValue) {
      if (newValue === "") {
        this.open();
      } else {
        this.close();
      }
    }
  }

  open() {
    document.querySelectorAll("quick-add[open]").forEach((el) => {
      if (el !== this) {
        el.removeAttribute("open");
      }
    });

    this.setAttribute("open", "");
    this.container.classList.add("is-quick-add-open");

    trapFocus(this.innerContainer, this.closeButton, true);

    this.addEventListener("keydown", this.onKeydown);
  }

  /**
   * @param {KeyboardEvent} e
   */
  onKeydown(e) {
    if (e.key === "Escape" || e.key === "esc") {
      this.close();
    }
  }

  close(clearTrapFocus = false) {
    this.container.classList.remove("is-quick-add-open");
    this.removeAttribute("open");
    this.removeEventListener("keydown", this.onKeydown);

    if (clearTrapFocus) {
      /** @type {HTMLElement} */
      // @ts-expect-error
      const openButton = this.parentElement.querySelector(
        ".product-card__quick-add-btn"
      );
      removeTrapFocus(openButton);
    }
  }

  onCloseClick() {
    this.close(true);
  }

  /**
   * @param {MouseEvent} e
   */
  onClick(e) {
    e.preventDefault();
    // @ts-ignore
    const variantName =
      this.querySelector("variant-selector")?.getAttribute("value") || "";

    const variant = getVariantInfo(this, variantName);

    // @ts-ignore
    const qty = this.querySelector("input[name=quantity]").valueAsNumber;

    /** @type {HTMLElement|null} */
    const relatedButton =
      this.parentElement?.querySelector(".product-card__quick-add-btn") || null;
    addToCartAndOpenCart(variant.id, qty, null, null, relatedButton).then(
      () => {
        this.close(false);
      }
    );
  }
}

customElements.define("quick-add", QuickAdd);

class ProductCardLegacy extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLButtonElement} */
    // @ts-expect-error
    this.button = this.querySelector(".product-card__quick-add-btn");

    /** @type {import('./quick-add').QuickAdd} */
    // @ts-ignore
    this.quickAdd = this.querySelector("quick-add");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.innerContainer = this.querySelector(".quick-add__container");

    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleInView = this.handleInView.bind(this);

    // @ts-ignore
    this.addEventListener("change", this.onChange.bind(this));
    this.addEventListener("in-view", this.handleInView);

    this.button.addEventListener("click", this.onButtonClick);
  }

  onButtonClick() {
    if (this.hasAttribute("open")) {
      this.quickAdd.removeAttribute("open");
    } else {
      this.quickAdd.setAttribute("open", "");
    }
  }

  /**
   * @param {CustomEvent} e
   */
  onChange(e) {
    if (!e.detail) {
      return;
    }

    const status = getStockStatus(this, e.detail);
    this.setAttribute("stock-status", status);
    updateContentWithVariant(this, e.detail, true);
  }

  handleInView() {
    const product = getProductData(this);
    const variantTitle =
      this.querySelector("variant-selector")?.getAttribute("value");

    const variant = variantTitle
      ? product.variants.find((x) => x.title === variantTitle)
      : product.variants[0];

    if (!variant) {
      console.error("Could not find variant for product card event", this);
      return;
    }

    const category = this.getAttribute("category") || "";
    const source = this.getAttribute("source") || "";

    trackProductCardViewed(product, variant.id, category, source);
  }
}

//
customElements.define("product-card-legacy", ProductCardLegacy);

const listUrl =
  "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe";

const emailExpr =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * @param {string} email
 * @returns {boolean}
 */
function validateEmail(email) {
  return emailExpr.test(String(email).toLowerCase());
}

/**
 * @param {string} email
 * @param {number} variantId
 * @param {number} productId
 * @param {boolean} subscribe
 */
const addUserToKlaviyoBackInStockList = async (
  email,
  variantId,
  productId,
  subscribe
) => {
  const formData = [];

  formData.push("a=QwSiud ");
  formData.push("variant=" + variantId);
  formData.push("product=" + productId);
  formData.push("g=Tze3qR");
  formData.push("email=" + encodeURIComponent(email));
  formData.push("platform=shopify");
  formData.push(`subscribe_for_newsletter=${subscribe}`);

  const options = {
    method: "POST",
    body: formData.join("&"),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  await fetch(listUrl, options);
};

class BackInStock extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLFormElement} */
    // @ts-ignore
    this.form = this.querySelector("form");

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  /**
   * @param {SubmitEvent} e
   */
  async onSubmitHandler(e) {
    e.preventDefault();

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const emailInput = this.querySelector('input[name="klaviyo_email"]');

    /** @type {HTMLInputElement|null} */
    const optInCheckbox = this.querySelector('input[name="klaviyo_opt_in"]');

    /** @type {HTMLInputElement} */
    // @ts-ignore
    const productInput = this.querySelector('input[name="klaviyo_product_id"]');

    const mode = this.getAttribute("mode");

    const productId = Number(productInput.value);
    const variantId = Number(this.getAttribute("variant-id"));
    const email = emailInput.value;
    const optIn = optInCheckbox ? optInCheckbox.checked : false;

    const optInParam = optInCheckbox
      ? // @ts-ignore
        this.querySelector("input[name=klaviyo_opt_in_param]").value
      : "";

    const result = validateEmail(email);

    if (result == false) {
      this.setAttribute("state", "error");
      return;
    }

    this.setAttribute("state", "saving");

    if (mode === "coming-soon") {
      const listId = this.getAttribute("coming-soon-list-id");
      if (!listId) {
        console.error("Klaviyo coming soon list id is null, please fix");
      }

      // @ts-ignore
      await addUserToList(listId, email, {
        $source: "PDP",
        [optInParam]: optIn,
        [`coming_soon_product_${productId}`]: true,
        [`coming_soon_variant_${variantId}`]: true,
      });
    } else {
      await addUserToKlaviyoBackInStockList(email, variantId, productId, optIn);
    }
    this.setAttribute("mode", `submitted-${mode}`);
    this.setAttribute("state", "complete");
  }
}

customElements.define("back-in-stock", BackInStock);

class ProductReviews extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick);
  }

  /**
   * @param {MouseEvent} e
   */
  onClick(e) {
    if (e.target instanceof HTMLElement) {
      /** @type {HTMLElement} */
      // @ts-ignore
      const productInfo = document.querySelector("product-info");
      const product = getProductData(productInfo);

      if (e.target.matches(".write-question-button")) {
        trackQuestionStarted(product);
        return;
      }

      if (e.target.matches(".write-review-button")) {
        trackReviewStarted(product);
        return;
      }
    }
  }
}
customElements.define("product-reviews", ProductReviews);

class ObservableContainer extends HTMLElement {
  /** @type {IntersectionObserver|null} */
  observer = null;

  constructor() {
    super();
    /** @type {NodeListOf<HTMLElement>} */
    this.elements = this.querySelectorAll("[data-observe]");
  }

  connectedCallback() {
    const options = {
      threshold: 0.35,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          this.observer &&
          entry.isIntersecting &&
          entry.target instanceof HTMLElement
        ) {
          this.observer.unobserve(entry.target);
          entry.target.dispatchEvent(
            new CustomEvent("in-view", {
              detail: entry.target,
              bubbles: true,
            })
          );
        }
      });
    }, options);

    this.elements.forEach((s) => this.observer?.observe(s));
  }

  disconnectedCallback() {
    this.elements.forEach((s) => this.observer?.unobserve(s));
    this.observer = null;
  }
}

customElements.define("observable-container", ObservableContainer);

const cartStrings = {
  quantityError: "You can only add [quantity] of this item to your cart.",
};

class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
  }

  connectedCallback() {
    // @ts-ignore
    this.addEventListener("change", this.onChange.bind(this));
  }

  disconnectedCallback() {
    // @ts-ignore
    this.removeEventListener("change", this.onChange.bind(this));
  }

  /**
   * @param {CustomEvent<import("./cart-item").CartItemChangeData>} event
   */
  onChange(event) {
    this.updateLineItem(
      event.detail.line,
      event.detail.quantity,
      event.detail.variant_id,
      event.detail.selling_plan
    );
  }

  /**
   * @param {number} index
   * @param {number} quantity
   */
  trackChangedQuantityEvent(index, quantity) {
    try {
      /**
       * @type {import("./cart-item").CartItem}
       */
      // @ts-ignore
      const cartItem = this.querySelector(`cart-item[index="${index}"]`);
      const data = cartItem.getInlineProductData();

      if (quantity === 0) {
        trackCartItemRemoved(data);
      } else {
        trackCartItemQuantityChanged({ ...data, quantity });
      }
    } catch (e) {
      console.error("Failed to track chagned qty event", e);
    }
  }

  /**
   * @param {number} line
   * @param {number} quantity
   * @param {number} variantId
   * @param {number|null} sellingPlan
   */
  async updateLineItem(line, quantity, variantId, sellingPlan) {
    this.enableLoading();

    /** @type {import('./cart-drawer').CartDrawer} */
    // @ts-ignore
    const cart = document.querySelector("cart-drawer");
    this.trackChangedQuantityEvent(line, quantity);

    /**
     * @type {HTMLElement}
     */
    // @ts-ignore
    const cartItem = cart.querySelector("cart-item[index='" + line + "']");

    // There is a weird bug where passing index can returns an error for a line item that doesn't exist
    // in the cart. So index = 1 can cause an issue even though  it's the only item in the cart.
    // Pretty sure it's a platform bug and hopefully temporary; but for now we'll just the key instead.
    const key = cartItem.getAttribute("key");

    let rawBody = {
      id: key,
      quantity,
      sections: cart.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      selling_plan: sellingPlan,
    };

    const body = JSON.stringify(rawBody);

    return fetch(`${window.routes.cart_change_url}?z=1`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);

        /** @type {HTMLInputElement} */
        // @ts-ignore
        const quantityElement = document.getElementById(
          `Drawer-quantity-${line}`
        );

        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          console.error("Cart errors", parsedState.errors);
          quantityElement.value = quantityElement.getAttribute("value") || "";
          await cart.refreshCart(true);
          return;
        }

        // We might have deleted the last item, so no line item to update in the UI
        if (items.length > 0) {
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;

          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === "undefined") ; else {
              cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              );
            }
          }
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
          line: line,
        });
      })
      .catch((e) => {
        console.error("Error updating cart", e);
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  enableLoading() {
    const drawer = document.querySelector("cart-drawer");
    drawer?.setAttribute("state", "loading");
  }

  disableLoading() {
    const drawer = document.querySelector("cart-drawer");
    drawer?.removeAttribute("state");
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/**
 * @type {FGCartNoop}
 */
/**
 * @param {import('../types/cart.js').Cart} cart
 * @param {FGSetting} fg
 * @returns {boolean}
 */
function checkGWP(cart, fg) {
  let meetsAll = false;

  for (const rule of fg.rules) {
    let qty = 0;
    let subtotal = 0;
    let isRuleMet = false;

    for (const item of cart.items) {
      if (item.properties._freegift) {
        continue;
      }

      const allowSubscriptions =
        rule.matchType === "any" || rule.matchType === "subscription_only";
      const allowOnetime =
        rule.matchType === "any" || rule.matchType === "onetime_only";

      if (allowSubscriptions === false && item.selling_plan_allocation) {
        continue;
      }

      if (allowOnetime === false && !item.selling_plan_allocation) {
        continue;
      }

      if (rule.type === "min_quantity") {
        const gid = `gid://shopify/Product/${item.product_id}`;
        if (rule.products.length === 0 || rule.products.includes(gid)) {
          qty += item.quantity;
          if (qty >= rule.value) {
            isRuleMet = true;
            break;
          }
        }
        continue;
      }

      if (rule.type === "min_subtotal") {
        if (rule.isGrandTotal) {
          subtotal += item.discounted_price * item.quantity;
        } else {
          subtotal += item.original_line_price;
        }

        if (subtotal >= rule.value * 100) {
          isRuleMet = true;
          break;
        }
        continue;
      }
    }

    if (!isRuleMet) {
      meetsAll = false;
      break;
    } else {
      meetsAll = true;
    }
  }

  return meetsAll;
}

/**
 * @param {import('../types/cart.js').Cart} cart
 * @param {FGSetting[]} settings
 */
function buildGWPChanges(cart, settings) {
  /**
   * @type {FGCartOperation[]}
   */
  const changes = [];

  /**
   * @type {Map<number, FGSetting>}
   */
  let validGifts = new Map();

  for (const fg of settings) {
    if (checkGWP(cart, fg)) {
      validGifts.set(fg.id, fg);
    }
  }

  for (const item of cart.items) {
    if (!item.properties._freegift) {
      continue;
    }

    const activeGiftId = item.properties._freegift;

    if (validGifts.has(activeGiftId) && item.original_line_price === 0) {
      validGifts.delete(activeGiftId);
    } else {
      changes.push({
        type: "remove",
        key: item.key,
      });
    }
  }

  // Remaining items in map will need to be added
  for (const [id, fg] of validGifts) {
    changes.push({
      type: "add",
      ruleId: id,
      variantId: Number(fg.freegift_variant_id.split("/").pop()),
    });
  }

  // console.log("%cChanges needed", "color:yellow;font-weight:bold", changes);
  return changes;
}

class CartDrawer extends HTMLElement {
  /**
   * @type {(()=> void) | undefined}
   */
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-expect-error
    const toggleButton = document.querySelector("#show-cart-drawer-btn");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.container = document.querySelector(".cart-drawer[role='dialog']");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    /** @type {HTMLElement|null} */
    this.activeElement = null;

    this.addEventListener("keyup", (evt) => {
      evt.code === "Escape" && this.close();
    });

    // @ts-ignore
    this.querySelector(".cart-drawer__overlay").addEventListener(
      "click",
      this.close
    );

    toggleButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(toggleButton);
    });
  }

  async connectedCallback() {
    // @ts-ignore
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.onCartUpdate(event);
      }
    );

    if (window.location.hash === "#show_cart") {
      this.open();
    }

    const isAdjusted = await this.adjustFreeGifts(this.getCartItems());

    if (isAdjusted) {
      this.refreshCart(false);
      return;
    }
  }

  /**
   * @param {Record<string, number>} updates
   * @returns {Promise<boolean>}
   * */
  async updateItems(updates) {
    /** @type {CartDrawerItems} */
    // @ts-ignore
    const drawerItems = this.querySelector("cart-drawer-items");
    drawerItems.enableLoading();

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    if (res.status < 200 || res.status > 299) {
      return false;
    }

    const data = await res.json();
    await this.renderCartRelatedSections(data.sections);
    return true;
  }

  /**
   * @param {string|number} variantId
   * @param {number} fgId
   * @returns {Promise<void>}
   *
   */
  async addFreeGift(variantId, fgId) {
    /** @type {CartDrawerItems} */
    // @ts-ignore
    const drawerItems = this.querySelector("cart-drawer-items");
    drawerItems.enableLoading();

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _freegift: fgId,
        },
      }),
    });
  }

  /**
   * @param {boolean} [runFreegiftLogic]
   */
  async refreshCart(runFreegiftLogic = true) {
    const sections = this.getSectionsToRender()
      .map((s) => s.section)
      .join(",");

    const res = await fetch(`/?sections=${sections}`, {
      method: "GET",
    });
    const data = await res.json();
    await this.renderCartRelatedSections(data, runFreegiftLogic);
  }

  /**
   * @returns {import('./cart-drawer-items').CartDrawerItems}
   */
  getCartItems() {
    // @ts-ignore
    return this.querySelector("cart-drawer-items");
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  /**
   * @param {any} data
   */
  async onCartUpdate(data) {
    // @ts-expect-error
    document.activeElement.blur();

    const prevCount = this.querySelectorAll("cart-item").length;
    await this.renderCartRelatedSections(data.cartData.sections);
    const items = this.querySelectorAll("cart-item");
    const nextCount = items.length;

    this.open(data.triggerElement);
    this.ensureFocusTrapped();

    if (items.length === 0) {
      return;
    }

    // If same count, activate the item by the index
    if (prevCount === nextCount) {
      const indexToSelect = items[data.line - 1] ? data.line - 1 : 0;

      requestAnimationFrame(() => {
        // @ts-expect-error
        items[indexToSelect].focus();
      });
      return;
    }

    // Just select first item
    requestAnimationFrame(() => {
      // @ts-expect-error
      items[0].focus();
    });
  }

  /**
   * @param {import('./cart-drawer-items').CartDrawerItems} drawer
   * @returns {Promise<boolean>}
   */
  async adjustFreeGifts(drawer) {
    try {
      const settings = JSON.parse(drawer.getAttribute("fg-settings") || "[]");
      const cartData = JSON.parse(
        // @ts-ignore
        drawer.querySelector(".cart-data")?.innerHTML
      );

      const changes = buildGWPChanges(cartData, settings);

      for (const change of changes) {
        if (change.type === "add") {
          await this.addFreeGift(change.variantId, change.ruleId);
        } else if (change.type === "remove") {
          await this.updateItems({ [change.key]: 0 });
        }
      }

      return changes.length > 0;
    } catch (e) {
      console.error("[FG ERROR]", e);
      return true;
    }
  }

  /**
   * @param {Record<string, string>} sections
   * @param {boolean} [runFreegiftLogic]
   */
  async renderCartRelatedSections(sections, runFreegiftLogic = true) {
    for (const section of this.getSectionsToRender()) {
      /** @type {HTMLElement} */
      // @ts-ignore
      const elementToReplace =
        // @ts-ignore
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      const element = this.getSectionElement(
        sections[section.section],
        section.selector
      );

      if (section.id === "CartDrawer") {
        /** @type {CartDrawerItems} */
        // @ts-ignore
        const drawer = element.querySelector("cart-drawer-items");

        if (runFreegiftLogic) {
          const hasAdjustments = await this.adjustFreeGifts(drawer);

          if (hasAdjustments) {
            await this.refreshCart(false);
            return;
          }
        }
      }

      elementToReplace.innerHTML = element.innerHTML;
    }

    this.updateEmptyState();
    this.disableLoading();
  }

  ensureFocusTrapped() {
    const btn = this.querySelector("button");
    trapFocus(this.container, btn, true);
  }

  enableLoading() {
    /** @type {CartDrawerItems} */
    // @ts-ignore
    const drawerItems = this.querySelector("cart-drawer-items");
    drawerItems.enableLoading();
  }

  disableLoading() {
    /** @type {CartDrawerItems} */
    // @ts-ignore
    const drawerItems = this.querySelector("cart-drawer-items");
    drawerItems.disableLoading();
  }

  /**
   * @param {string} html
   * @param {string} selector
   * @returns {HTMLElement}
   */
  getSectionElement(html, selector) {
    // @ts-ignore
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  /** @param {HTMLElement|null} [triggeredBy] */
  open(triggeredBy) {
    this.removeAttribute("inert");

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    /** @type {HTMLElement|null} */
    const savedItems = this.querySelector("cart-saved-items");

    if (savedItems) {
      savedItems.setAttribute("open", "");
    }

    this.updateEmptyState();

    if (!document.body.classList.contains("is-cart-drawer-open")) {
      trackCartViewed();
    }

    setTimeout(() => {
      document.body.classList.add("is-cart-drawer-open");
    });

    this.addEventListener(
      "transitionend",
      () => {
        this.ensureFocusTrapped();
      },
      { once: true }
    );
  }

  isOpen() {
    return document.body.classList.contains("is-cart-drawer-open");
  }

  updateEmptyState() {
    const cartItems = this.getCartItems();
    const isEmpty = cartItems.getAttribute("data-cart-count") === "0";
    this.classList.toggle("is-empty", isEmpty);
  }

  close() {
    this.setAttribute("inert", "");
    document.body.classList.remove("is-cart-drawer-open");
    removeTrapFocus(this.activeElement);
  }

  openPointsHistory() {
    /** @type {import('./points-history').PointsHistory|null} */
    const pointsHistory = this.querySelector("points-history");
    if (pointsHistory) {
      pointsHistory.setAttribute("open", "");
    }
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "show-cart-drawer-btn",
        section: "cart-icon-bubble",
        selector: ".header__cart-btn-content",
      },
    ];
  }

  /** @param {HTMLElement|null} element */
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

/**
 * Represents data for a particular item.
 * @typedef {Object} CartItemChangeData
 * @property {number} line - The line index.
 * @property {number} quantity - The quantity of the item.
 * @property {number} variant_id - The variant id
 * @property {number|null} selling_plan - The selling plan ID, or an empty string if not available.
 */

class CartItem extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-ignore
    this.container = this.querySelector(".cart-drawer__item");

    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("change", this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.handleChange);
  }

  getInlineProductData() {
    return {
      variant_id: this.getAttribute("variant-id"),
      product_id: this.getAttribute("product-id"),
      name: this.getAttribute("product-name"),
      variant_name: this.getAttribute("variant-name"),
      sku: this.getAttribute("sku"),
      price: Number(this.getAttribute("price")),
    };
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    /** @type {HTMLElement} */
    // @ts-ignore
    const target = event.target;

    if (target.nodeName === "CART-ITEM") {
      return;
    }

    event.stopPropagation();

    // @ts-ignore
    const qty = this.querySelector(".quantity-input__qty-amount").value;
    const subscribeSave = this.querySelector("subscribe-save");
    const planId = subscribeSave ? subscribeSave.getAttribute("value") : null;

    /** @type {CartItemChangeData} */
    const data = {
      line: Number(this.getAttribute("index")),
      quantity: Number(qty),
      variant_id: Number(this.getAttribute("variant-id")),
      selling_plan: planId ? Number(planId) : null,
    };

    this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: true,
        detail: data,
      })
    );
  }
}

customElements.define("cart-item", CartItem);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      /** @type {import("./cart-drawer-items").CartDrawerItems} */
      // @ts-ignore
      const cartItems = this.closest("cart-drawer-items");
      cartItems.updateLineItem(Number(this.dataset.index), 0, 0, null);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

const ITEM_KEY = "NUUN_SAVED_VARIANTS";

/**
 * @typedef {Object} SavedProductInfo
 * @property {string} url - The variant URL
 * @property {number} quantity - The quantity
 * @property {number|null} planId - The selling plan ID
 */

/**
 * @param {string} url
 * @param {number} quantity
 * @param {number|null} planId
 */
function saveProduct(url, quantity, planId) {
  let items = getSafeValue();
  const newItem = { url, quantity, planId };

  // We treat the products unique by URL even if different quantity or plan
  // So make sure to remove an old product url when adding a new one.
  items = items.filter((item) => item.url !== url);
  items.push(newItem);

  setValue(items);
}

function getSavedProducts() {
  const products = getSafeValue();
  return products;
}

/**
 * @param {string} url
 */
function removeSavedProduct(url) {
  const items = getSafeValue();
  const updatedItems = items.filter((item) => item.url !== url);
  setValue(updatedItems);
}

/**
 * @param {SavedProductInfo[]} data
 */
const setValue = (data) => {
  localStorage.setItem(ITEM_KEY, JSON.stringify([...data]));
};

/**
 * @returns {SavedProductInfo[]}
 */
const getSafeValue = () => {
  const str = localStorage.getItem(ITEM_KEY);

  /** @type {SavedProductInfo[]} */
  const products = [];

  if (!str) {
    return products;
  }

  try {
    const parsed = JSON.parse(str);

    if (Array.isArray(parsed)) {
      for (const item of parsed) {
        if (typeof item === "object") {
          products.push({
            url: item.url,
            quantity: item.quantity,
            planId: item.planId,
          });
        }
      }
    }
  } catch (err) {
    console.error("Error parsing saved variants", err);
  }

  return products;
};

const MAX_LIST = 10;

class CartSaveButton extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick() {
    const title = this.dataset.title;
    const handle = this.dataset.handle;
    const variantId = this.dataset.variantId;
    const saved = getSavedProducts();

    if (saved.length >= MAX_LIST) {
      showAlertDialog(
        `You can only save a maximum of ${MAX_LIST} products to your saved list.`
      );
      return;
    }

    const qty = Number(this.dataset.qty || 1);
    const planId = this.dataset.planId ? Number(this.dataset.planId) : null;

    saveProduct(`/products/${handle}?variant=${variantId}`, qty, planId);

    /** @type {import("./cart-drawer-items").CartDrawerItems} */
    // @ts-ignore
    const cartItems = this.closest("cart-drawer-items");

    cartItems
      .updateLineItem(Number(this.dataset.index), 0, 0, null)
      .then(() => {
        successToast(`<p>"${title}" has been saved for later.</p>`);
      });

    /**
     * @type {import("./cart-item").CartItem}
     */
    // @ts-ignore
    const cartItem = this.closest("cart-item");
    const data = cartItem.getInlineProductData();
    trackCartItemSaveForLater(data);
  }
}

customElements.define("cart-save-button", CartSaveButton);

// This has an open property. Add the open property when you want this to render the items.
// The cart drawer will set this property when it first opens to fetch everything and then
// future updates will rerender from the cache. Avoids unneeded network calls.
class CartSavedItems extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-ignore
    this.container = this.querySelector(".cart-saved");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.items = this.querySelector(".cart-saved__items");

    this.onChange = this.onChange.bind(this);
  }

  static get observedAttributes() {
    return ["open"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   * */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open" && oldValue !== newValue && newValue === "") {
      this.renderSavedSections();
    }
  }

  connectedCallback() {
    this.addEventListener("change", this.onChange);

    /** @type {import('./cart-drawer').CartDrawer} */
    // @ts-ignore
    const cart = this.closest("cart-drawer");

    // Since this can be replaced with the sections API we'll keep it in sync
    // so it renders correctly.
    if (cart.isOpen() && this.hasAttribute("open") === false) {
      this.setAttribute("open", "");
    }
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange);
  }

  onChange() {
    this.updateEmptyStatus();
    this.storeLocalState();
  }

  storeLocalState() {
    const html = this.items.innerHTML;
    const existing = document.getElementById("cart-saved-items-cache");

    if (existing) {
      existing.parentNode?.removeChild(existing);
    }

    const element = document.createElement("script");
    element.id = "cart-saved-items-cache";
    element.type = "text/x-template";
    element.innerHTML = html;
    document.body.appendChild(element);
  }

  /**
   * @returns {Map<string, HTMLElement>}
   */
  fetchLocalState() {
    /** @type {Map<string, HTMLElement>} */
    const map = new Map();

    const scriptTag = document.getElementById("cart-saved-items-cache");

    if (!scriptTag) {
      return map;
    }

    const stub = document.createElement("div");
    stub.innerHTML = scriptTag.innerHTML;

    for (const element of stub.children) {
      if (element instanceof HTMLElement) {
        const url = element.dataset.url || "";
        /** @type {HTMLElement} */
        // @ts-ignore
        const clone = element.cloneNode(true);
        map.set(url, clone);
      }
    }

    return map;
  }

  updateEmptyStatus() {
    this.container.classList.toggle(
      "is-empty",
      this.items.children.length === 0
    );
  }

  async renderSavedSections() {
    const savedProducts = getSavedProducts();
    const cachedItems = this.fetchLocalState();

    this.items.innerHTML = "";

    for (const savedProduct of savedProducts) {
      const cachedItem = cachedItems.get(savedProduct.url);

      if (cachedItem) {
        this.items.appendChild(cachedItem);
        continue;
      }

      const res = await fetch(`${savedProduct.url}&sections=cart-saved-item`, {
        headers: { "content-type": "application/json" },
      });

      const data = await res.json();
      const rawHTML = data["cart-saved-item"];

      if (rawHTML) {
        const html = this.getSectionInnerHTML(
          rawHTML,
          ".cart-saved-item-wrapper"
        );

        const stub = document.createElement("div");
        stub.innerHTML = html;

        /** @type {HTMLElement} */
        // @ts-ignore
        const cartItemElement = stub.children[0];

        /** @type {HTMLInputElement} */
        // @ts-ignore
        const qtyInput = cartItemElement.querySelector(
          "input[name='quantity']"
        );

        // We have to set both so the the value is in the DOM when we cache the HTML
        qtyInput.value = savedProduct.quantity.toString();
        qtyInput.setAttribute("value", savedProduct.quantity.toString());

        if (savedProduct.planId) {
          cartItemElement.setAttribute("plan-id", String(savedProduct.planId));
        }

        this.items.appendChild(cartItemElement);
      }
    }

    this.updateEmptyStatus();
    this.storeLocalState();
  }

  /**
   * @param {string} html
   * @param {string} selector
   */
  getSectionInnerHTML(html, selector) {
    // @ts-ignore
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("cart-saved-items", CartSavedItems);

class CartSavedItem extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".cart-drawer__item-actions button");
    this.onClickButton = this.onClickButton.bind(this);
    this.onChanged = this.onChange.bind(this);
  }

  connectedCallback() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onClickButton);
    });
    this.addEventListener("change", this.onChanged);
  }

  disconnectedCallback() {
    this.buttons.forEach((button) => {
      button.removeEventListener("click", this.onClickButton);
    });
    this.removeEventListener("change", this.onChanged);
  }

  onChange() {
    // @ts-ignore
    const qty = Number(this.querySelector("input[name='quantity']").value);
    const planId = parseInt(this.getAttribute("plan-id") || "") || null;
    const url = this.getAttribute("data-url");
    saveProduct(url, qty, planId);
  }
  /**
   * @param {Event} event
   */
  onClickButton(event) {
    if (event.target instanceof HTMLElement) {
      const action = event.target.dataset.action;

      if (action === "remove") {
        this.removeItem(
          event.target.dataset.title || "",
          event.target.dataset.url || ""
        );
        return;
      }

      if (action === "add-to-cart") {
        this.addToCart(
          event.target.dataset.title || "",
          event.target.dataset.url || ""
        );
        return;
      }
    }
  }

  /**
   * @param {string} title
   * @param {string} url
   */
  addToCart(title, url) {
    const variantId = Number(url.split("?variant=").pop());

    // @ts-ignore
    const qty = Number(this.querySelector("input[name='quantity']").value);
    const planId = parseInt(this.getAttribute("plan-id") || "") || null;

    removeSavedProduct(url);

    addToCartAndOpenCart(variantId, qty, planId, this).then(() => {
      successToast(`"${title}" added to your cart`);
    });
  }

  /**
   * @param {string} title
   * @param {string} url
   */
  removeItem(title, url) {
    removeSavedProduct(url);
    //
    /** @type {HTMLElement} */
    // @ts-ignore
    const parent = this.parentElement;

    parent.removeChild(this);
    parent.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    successToast(`"${title}" removed from your list.`);
  }
}

customElements.define("cart-saved-item", CartSavedItem);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("cart-upsell", CartUpsell);

class CartUpsellItem extends HTMLElement {
  constructor() {
    super();

    /**@type {HTMLButtonElement} */
    // @ts-ignore
    this.button = this.querySelector(".cart-upsell__atc-btn");
    this.onClickAddToCart = this.onClickAddToCart.bind(this);
  }

  connectedCallback() {
    this.button.addEventListener("click", this.onClickAddToCart.bind(this));
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.onClickAddToCart.bind(this));
  }

  onClickAddToCart() {
    const variantId = Number(this.getAttribute("variant-id"));
    const title = this.getAttribute("title");
    // @ts-ignore
    const qty = this.querySelector("input[name='quantity']").value;

    addToCartAndOpenCart(variantId, qty, null, this).then(() => {
      successToast(`Added ${title} x ${qty} to cart`);
    });
  }
}

customElements.define("cart-upsell-item", CartUpsellItem);

class CartLoyalty extends HTMLElement {
  constructor() {
    super();

    this.flip = this.flip.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.querySelectorAll(".cart-loyalty__flip-btn").forEach((btn) => {
      btn.addEventListener("click", this.flip);
    });

    this.querySelectorAll(".cart-loyalty__close-btn").forEach((btn) => {
      btn.addEventListener("click", this.close);
    });

    this.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  static get observedAttributes() {
    return ["open"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) {
      return;
    }

    if (name === "open") {
      if (this.hasAttribute("open")) {
        this.open();
      } else {
        this.close();
      }
    }
  }

  open() {
    this.dataset.state = "open";
    document.body.addEventListener("click", this.close);
  }

  close() {
    this.dataset.state = "closed";
    this.removeAttribute("open");
    document.body.removeEventListener("click", this.close);
  }

  /**
   * @param {Event} e
   */
  flip(e) {
    e.stopPropagation();
    const mode = this.getAttribute("mode");
    const nextMode = mode == "how" ? "why" : "how";

    this.addEventListener(
      "transitionend",
      () => {
        this.classList.remove("is-animating");
      },
      { once: true }
    );
    this.setAttribute("mode", nextMode);
    this.classList.add("is-animating");
  }
}

customElements.define("cart-loyalty", CartLoyalty);

class CartCloseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    /** @type {import("./cart-drawer").CartDrawer} */
    // @ts-ignore
    const cart = document.querySelector("cart-drawer");
    cart.close();
  }
}

customElements.define("cart-close-button", CartCloseButton);

class CartFooter extends HTMLElement {
  constructor() {
    super();

    this.loyaltyComponent = this.querySelector("cart-loyalty");
    this.checkoutButton = this.querySelector(".cart-drawer__checkout-btn");

    this.showLoyalty = this.showLoyalty.bind(this);
    this.startCheckout = this.startCheckout.bind(this);

    this.querySelector(".subscribe-save-info__btn")?.addEventListener(
      "click",
      this.showLoyalty
    );

    this.checkoutButton?.addEventListener("click", this.startCheckout);
  }

  async saveUTMParams() {
    try {
      const params = getStoredUTMParams();
      if (!params) {
        return;
      }
      await API.setCartAttribute("utm_params", params);
    } catch (e) {
      console.error("Error saving UTM params", e);
    }
  }

  async startCheckout() {
    /** @type {HTMLElement} */
    // @ts-ignore
    const cartDrawer = document.querySelector("cart-drawer");

    try {
      cartDrawer.classList.add("is-submitting");

      let checkoutUrl = "/checkout";
      const reward = getSelectedReward();
      let redemption = null;

      await this.saveUTMParams();

      if (reward) {
        redemption = await this.makeRedemptionToCart(reward.rewardId);
      }

      if (redemption) {
        // Non recharge urls have to appy discount and then redirect
        checkoutUrl = `/discount/${redemption.couponCode}?redirect=${checkoutUrl}`;
      }

      trackCheckoutStarted();
      removeSelectedReward();

      window.location.href = checkoutUrl;
    } catch (err) {
      console.error("Error starting checkout", err);
      cartDrawer.classList.remove("is-submitting");
    }
  }

  /**
   * @param {string} couponSwellId
   */
  async makeRedemptionToCart(couponSwellId) {
    return new Promise((res, reject) => {
      /** @param {any} redemptionCode */
      const onSuccess = function (redemptionCode) {
        res(redemptionCode);
      };

      /** @param {any} err */
      const onError = function (err) {
        console.error("Discount error", err);
        showAlertDialog(
          "Whoops! Something went wrong trying to apply the discount. Please try again!"
        );
        reject(err);
      };

      window.swellAPI.makeRedemption(
        { redemptionOptionId: couponSwellId, delayPointDeduction: true },
        onSuccess,
        onError
      );
    });
  }

  /**
   * @param {Event} e
   */
  showLoyalty(e) {
    if (!this.loyaltyComponent) {
      return;
    }
    e.stopPropagation();

    const isOpen = this.loyaltyComponent.hasAttribute("open");

    if (isOpen) {
      this.loyaltyComponent.removeAttribute("open");
    } else {
      this.loyaltyComponent.setAttribute("open", "");
    }
  }
}

customElements.define("cart-footer", CartFooter);

class RewardSelect extends HTMLElement {
  constructor() {
    super();

    /** @type {NodeListOf<HTMLButtonElement>} */
    this.closeButtons = this.querySelectorAll("[data-close-btn]");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.isRendered = false;
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    this.closeButtons.forEach((btn) => {
      btn.addEventListener("click", this.close);
    });
  }

  static get observedAttributes() {
    return ["open"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) {
      return;
    }

    if (name === "open") {
      if (newValue === "") {
        this.open();
      } else {
        this.close();
      }
    }
  }

  open() {
    this.renderItems();
    this.dataset.state = "open";
    this.setAttribute("open", "");
    document.body.addEventListener("click", this.close);
  }

  close() {
    this.dataset.state = "closed";
    document.body.removeEventListener("click", this.close);
    this.removeAttribute("open");
  }

  renderItems() {
    if (this.isRendered) {
      return;
    }

    this.isRendered = true;

    /** @type {HTMLElement} */
    // @ts-ignore
    const itemsContainer = this.querySelector(".reward-select__items");
    const stub = document.createElement("div");
    // @ts-ignore
    const itemTemplate = this.querySelector("#rewardItemTemplate").innerHTML;
    const customer = window.swellAPI.getCustomerDetails();
    const options = window.swellAPI
      .getActiveRedemptionOptions()
      // @ts-ignore
      .sort(function (a, b) {
        if (a.costInPoints < b.costInPoints) return -1;
        if (b.costInPoints > b.costInPoints) return 1;
        return 0;
      });

    for (const option of options) {
      let discount = option.discountAmountCents
        ? option.discountAmountCents / 100
        : null;
      let percentage = option.discountAmountCents;
      let cost = option.costInPoints;

      let text = "";
      let amount = "";

      if (discount) {
        text = `<strong>$${discount}</strong> off for <strong>${cost}</strong> points`;
        amount = `$${discount}`;
      } else if (percentage) {
        text = `<strong>${percentage}%</strong> off for <strong>${cost}</strong> points`;
        amount = `${percentage}%`;
      }

      let htmlOptions = "";
      let buttonText = "Apply";

      if (customer.pointsBalance < cost) {
        htmlOptions = "disabled";
        buttonText = "Not Avail";
      }

      const data = {
        id: option.id,
        amount: amount,
        text: text,
        rewardName: option.name,
        htmlOptions: htmlOptions,
        buttonText: buttonText,
      };

      const row = placeholders(itemTemplate, data);
      stub.insertAdjacentHTML("beforeend", row);
    }

    itemsContainer.replaceChildren(...stub.children);

    this.querySelectorAll(".reward-select__item-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (e.target instanceof HTMLElement) {
          this.dispatchEvent(
            new CustomEvent("change", {
              bubbles: true,
              detail: {
                rewardId: e.target.getAttribute("data-reward-id") || "",
                rewardText: e.target.getAttribute("data-reward-text") || "",
              },
            })
          );
        }
        this.close();
      });
    });
  }
}

customElements.define("reward-select", RewardSelect);

class SubscribeSave extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLSelectElement} */
    // @ts-ignore
    this.select = this.querySelector("select");

    /** @type {HTMLInputElement} */
    // @ts-ignore
    this.checkbox = this.querySelector(".subscribe-save__real-cb");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.buttonText = this.querySelector(".subscribe-save__options-btn-text");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.popularText = this.querySelector(".subscribe-save__options-popular");

    this.onSelectChange = this.onSelectChange.bind(this);
    this.onCheckboxClick = this.onCheckboxClick.bind(this);
  }

  connectedCallback() {
    this.select.addEventListener("change", this.onSelectChange);
    this.checkbox.addEventListener("click", this.onCheckboxClick);
    this.setPlan();
  }

  disconnectedCallback() {
    this.select.removeEventListener("change", this.onSelectChange);
    this.checkbox.removeEventListener("click", this.onCheckboxClick);
  }

  setPlan() {
    if (this.checkbox.checked) {
      this.setAttribute("value", this.select.value);
    } else {
      this.removeAttribute("value");
    }
  }

  /**
   * @param {Event} e
   */
  onCheckboxClick(e) {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }

    if (!e.target.checked) {
      this.setPlan();
      return;
    }

    e.preventDefault();

    const discount = Number(this.getAttribute("discount"));

    showModalTerms(discount, () => {
      this.checkbox.checked = true;
      this.setPlan();
      this.dispatchEvent(new Event("change", { bubbles: true }));
    });
    return false;
  }

  onSelectChange() {
    const index = this.select.selectedIndex;
    const text = this.select.options[index].textContent;

    this.buttonText.textContent = text;
    this.setPlan();

    if (index === 0) {
      this.popularText.style.display = "";
    } else {
      this.popularText.style.display = "none";
    }
  }
}

customElements.define("subscribe-save", SubscribeSave);

class SubscribeSaveInfo extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.btn = this.querySelector(".subscribe-save-info__btn");

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    // @ts-ignore
    this.btn.addEventListener("click", this.show);
  }

  disconnectedCallback() {
    // @ts-ignore
    this.btn.removeEventListener("click", this.show);
    document.body.removeEventListener("click", this.hide);
  }

  /**
   * @param {ButtonMouseEvent} e
   */
  show(e) {
    e.stopPropagation();

    /** @type {NodeListOf<SubscribeSaveInfo>} */
    const existingElements = document.querySelectorAll("subscribe-save-info");
    existingElements.forEach((el) => {
      if (el !== this) {
        el.hide();
      }
    });

    if (this.dataset.state === "open") {
      this.hide();
      return;
    }

    this.dataset.state = "open";
    document.body.addEventListener("click", this.hide);
  }

  hide() {
    this.dataset.state = "closed";
    document.body.removeEventListener("click", this.hide);
  }
}

customElements.define("subscribe-save-info", SubscribeSaveInfo);

class FancyProductCard extends HTMLElement {
  constructor() {
    super();

    /** @type {import('./variant-selector.js').VariantSelector|null}*/
    this.variantSelector = this.querySelector("variant-selector");

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.submitButton = this.querySelector(".quick-add-btn");

    this.handleInView = this.handleInView.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleClickAddToCart = this.handleClickAddToCart.bind(this);
  }

  connectedCallback() {
    if (this.variantSelector) {
      // @ts-ignore
      this.variantSelector.addEventListener("change", this.handleVariantChange);
    }
    this.submitButton.addEventListener("click", this.handleClickAddToCart);

    this.addEventListener("in-view", this.handleInView);
  }

  disconnectedCallback() {
    if (this.variantSelector) {
      this.variantSelector.removeEventListener(
        "change",
        // @ts-ignore
        this.handleVariantChange
      );
    }

    this.submitButton.removeEventListener("click", this.handleClickAddToCart);
    this.removeEventListener("in-view", this.handleInView);
  }

  handleInView() {
    const product = getProductData(this);
    const variantTitle = this.variantSelector?.getAttribute("value");
    const variant = variantTitle
      ? product.variants.find((x) => x.title === variantTitle)
      : product.variants[0];

    if (!variant) {
      console.error("Could not find variant for product card event", this);
      return;
    }

    const category = this.getAttribute("category") || "";
    const source = this.getAttribute("source") || "";
    trackProductCardViewed(product, variant.id, category, source);
  }

  handleClickAddToCart() {
    // @ts-ignore
    const qty = this.querySelector("input[name='quantity']").value;
    const variant = getVariantInfo(
      this,
      // @ts-ignore
      this.variantSelector.getAttribute("value") || ""
    );

    addToCartAndOpenCart(variant.id, qty, null, this);
  }
  /**
   * @param {CustomEvent} event
   */
  handleVariantChange(event) {
    const variantTitle = this.variantSelector?.getAttribute("value") || "";
    const status = getStockStatus(this, variantTitle);
    this.setAttribute("stock-status", status);
    updateContentWithVariant(this, event.detail);

    const category = this.getAttribute("category") || "";
    const source = this.getAttribute("source") || "";
    const [product, variant] = getVariantInfoWithProduct(this, variantTitle);
    trackProductViewed(product, variant.id, category, source);
  }
}

customElements.define("fancy-product-card", FancyProductCard);

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement} */
    // @ts-ignore
    this.container = this.querySelector(".variant-selector");

    /** @type {HTMLElement} */
    // @ts-ignore
    this.selectedItem = this.querySelector(
      ".variant-selector__ui-selected-inner"
    );

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.triggerButton = this.querySelector(".variant-selector__ui-selected");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.listbox = this.querySelector("ul");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.handleKeydownEvent = this.handleKeydownEvent.bind(this);
    this.handleClickOutsideEvent = this.handleClickOutsideEvent.bind(this);

    this.isOutOfStockRendered = false;

    /** @type {HTMLElement|null} */
    this.activeElement = null;
  }

  static get observedAttributes() {
    return ["value"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "value" && oldValue !== newValue) {
      this.selectItemByTitle(newValue);
    }
  }

  connectedCallback() {
    this.container.addEventListener("click", this.handleClickEvent);
    this.addEventListener("keydown", this.handleKeydownEvent);
  }

  disconnectedCallback() {
    this.container.removeEventListener("click", this.handleClickEvent);
    this.removeEventListener("keydown", this.handleKeydownEvent);
  }

  open() {
    this.ensureSelectedItemHiddenInItems();
    this.container.classList.add("is-open");
    document.addEventListener("click", this.handleClickOutsideEvent);
    this.listbox.inert = false;
    this.triggerButton.setAttribute("aria-expanded", "true");

    const items = this.getVisibleItems();
    if (items.length > 0) {
      this.selectItemFromKeyboard(items[0]);
    }
  }

  close() {
    this.container.classList.remove("is-open");
    document.removeEventListener("click", this.handleClickOutsideEvent);
    this.triggerButton.setAttribute("aria-expanded", "false");
    this.listbox.inert = true;

    if (this.activeElement) {
      this.activeElement = this.triggerButton;
      window.setTimeout(() => {
        this.triggerButton.focus();
      });
    }
  }

  getVisibleItems() {
    return [...this.listbox.querySelectorAll("li")].filter(
      (el) => el.getAttribute("aria-selected") !== "true"
    );
  }

  /** @param {HTMLElement} item */
  selectItemFromKeyboard(item) {
    this.listbox
      .querySelectorAll("li")
      .forEach((el) => el.classList.remove("is-active"));

    item.focus();
    this.activeElement = item;
    this.activeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  ensureSelectedItemHiddenInItems() {
    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".variant-selector__ui-content-item");
    const value = this.getAttribute("value") || "";

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.dataset.value === value) {
        item.setAttribute("aria-selected", "true");
        item.classList.add("visually-hidden");
      } else {
        item.setAttribute("aria-selected", "false");
        item.classList.remove("visually-hidden");
      }
    }
  }

  /**
   * @param {MouseEvent} event
   */
  handleClickEvent(event) {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (event.target.matches(".variant-selector__ui-content-item")) {
      this.selectItem(event.target);
      return;
    }

    event.stopPropagation();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydownEvent(event) {
    const key = event.key;

    if (key === "Escape" || key === "esc") {
      this.close();
      event.stopPropagation();
      return;
    }

    if (this.isOpen() === false && (key === " " || key === "Enter")) {
      this.activeElement = this.triggerButton;
      this.open();
      event.preventDefault();
      return;
    }

    // Select item
    if (this.isOpen() && (key === " " || key === "Enter")) {
      event.preventDefault();
      if (this.activeElement && this.activeElement.tagName === "LI") {
        const item = this.activeElement;
        this.close();
        this.selectItem(item);
      }
      return;
    }

    if (this.isOpen() === false) {
      return;
    }

    if (key == "Tab") {
      this.close();
      return;
    }

    if (key === "ArrowUp") {
      this.selectPreviousItem();
      event.stopPropagation();
      return;
    }

    if (key === "ArrowDown") {
      this.selectNextItem();
      event.stopPropagation();
      return;
    }
  }

  selectPreviousItem() {
    const items = this.getVisibleItems();
    let prevIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        prevIndex = i - 1;
        break;
      }
    }

    if (items[prevIndex]) {
      this.activeElement = items[prevIndex];
      this.activeElement.focus();
    }
  }

  selectNextItem() {
    const items = this.getVisibleItems();
    let nextIndex = -1;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement === items[i]) {
        nextIndex = i + 1;
        break;
      }
    }

    if (items[nextIndex]) {
      this.activeElement = items[nextIndex];
      this.activeElement.focus();
    }
  }

  handleClickOutsideEvent() {
    this.close();
  }

  isOpen() {
    return this.container.classList.contains("is-open");
  }

  closeAll() {
    document
      .querySelectorAll("flavor-widget")
      // @ts-ignore
      .forEach((/** @type {FlavorWidget} */ el) => {
        el.close();
      });
  }

  /**
   * @param {string} title
   */
  selectItemByTitle(title) {
    const items = this.querySelectorAll(".variant-selector__ui-content-item");

    for (const item of items) {
      if (item instanceof HTMLElement) {
        if (item.dataset.value === title) {
          this.selectItem(item);
          break;
        }
      }
    }
  }

  /**
   * @param {HTMLElement} previewItem
   * @param {HTMLElement} selectedItem
   */
  updateSelectedItemPreview(previewItem, selectedItem) {
    /** @type {HTMLElement|null} */
    const previewCircle = previewItem.querySelector(
      ".variant-selector__ui-flavor-circle"
    );

    /** @type {HTMLElement|null} */
    const circleEl = selectedItem.querySelector(
      ".variant-selector__ui-flavor-circle"
    );

    /** @type {HTMLElement} */
    // @ts-ignore
    const titleEl = previewItem.querySelector(
      ".variant-selector__ui-flavor-title"
    );

    if (circleEl && previewCircle) {
      previewCircle.dataset.variant = circleEl.dataset.variant;
      previewCircle.dataset.shortVariant = circleEl.dataset.variant;
    }

    titleEl.textContent = selectedItem.dataset.value || "";
  }

  /**
   * @param {HTMLElement} item
   */
  selectItem(item) {
    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".flavor-widget__item");
    const flavor = item.dataset.value || "";

    const needsTrigger = flavor !== this.getAttribute("value");

    items.forEach((el) => {
      if (el.dataset.value === flavor) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });

    this.setAttribute("value", flavor);

    /** @type {HTMLElement} */
    // @ts-ignore
    const selectedEl = this.querySelector(".variant-selector__ui-selected");

    this.updateSelectedItemPreview(selectedEl, item);

    if (needsTrigger) {
      const event = new CustomEvent("change", {
        detail: flavor,
        bubbles: true,
      });
      this.dispatchEvent(event);
    }
  }
}

customElements.define("variant-selector", VariantSelector);

class FlavorWidget extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.container = this.querySelector(".variant-selector");

    /** @type {HTMLElement|null} */
    this.selectedItem = this.querySelector(
      ".variant-selector__ui-selected-inner"
    );

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.trigger = this.querySelector(".variant-selector__ui-selected");

    /** @type {HTMLElement} */
    // @ts-expect-error
    this.listbox = this.querySelector(".variant-selector__ui-content-list");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleClickOutsideEvent = this.handleClickOutsideEvent.bind(this);

    /** @type {HTMLElement|null} */
    this.activeElement = null;
  }

  static get observedAttributes() {
    return ["value", "size"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "value" && oldValue !== newValue) {
      this.selectItemByTitle(newValue);
      return;
    }

    if (name === "size" && oldValue !== newValue) {
      this.filterVariantsBySize(newValue);
    }
  }

  connectedCallback() {
    this.container.addEventListener("click", this.handleClickEvent);
    this.setFlavorImages();
    const size = this.getAttribute("size") || "";
    this.filterVariantsBySize(size);
    this.addEventListener("keydown", this.handleKeydown);
  }

  disconnectedCallback() {
    this.container.removeEventListener("click", this.handleClickEvent);
    this.removeEventListener("keydown", this.handleKeydown);
  }

  open() {
    this.filterVariantsBySize(this.getAttribute("size") || "");
    this.container.classList.add("is-open");
    document.addEventListener("keydown", this.handleDocumentKeyDown);
    document.addEventListener("click", this.handleClickOutsideEvent);
    this.trigger.setAttribute("aria-expanded", "true");
    this.listbox.inert = false;

    const items = this.getVisibleItems();
    if (items.length > 0) {
      this.selectItemFromKeyboard(items[0]);
    }
  }

  close() {
    this.container.classList.remove("is-open");
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
    document.removeEventListener("click", this.handleClickOutsideEvent);
    this.trigger.setAttribute("aria-expanded", "false");
    this.listbox.inert = true;

    this.listbox
      .querySelectorAll("li")
      .forEach((el) => el.classList.remove("is-active"));

    if (this.activeElement) {
      this.activeElement = this.trigger;
      setTimeout(() => {
        this.trigger.focus();
      });
    }
  }

  getVisibleItems() {
    return [...this.listbox.querySelectorAll("li")].filter(
      (el) => el.style.display !== "none"
    );
  }
  /**
   * @param  {string} size
   */
  filterVariantsBySize(size) {
    const currentFlavor = this.getAttribute("value") || "";

    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".variant-selector__ui-content-item");

    let itemToSelect = null;
    let hasOtherFlavors = false;

    for (const item of items) {
      const itemSize = item.dataset.size || "";

      if (itemSize !== size) {
        item.style.display = "none";
      } else if (item.dataset.value === currentFlavor) {
        item.style.display = "none";
        itemToSelect = item;
      } else {
        item.style.display = "";
        hasOtherFlavors = true;
      }
    }

    // @ts-ignore
    this.querySelector(".variant-selector").classList.toggle(
      "is-empty",
      !hasOtherFlavors
    );

    if (!itemToSelect) {
      for (const item of items) {
        if (item.style.display !== "none") {
          itemToSelect = item;
          break;
        }
      }
    }

    if (itemToSelect) {
      this.selectItem(itemToSelect);
    }
  }

  /**
   * @param {MouseEvent} event
   */
  handleClickEvent(event) {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (event.target.matches(".variant-selector__ui-content-item")) {
      this.selectItem(event.target);
      return;
    }

    event.stopPropagation();
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  /** @param {HTMLElement} item */
  selectItemFromKeyboard(item) {
    this.listbox
      .querySelectorAll("li")
      .forEach((el) => el.classList.remove("is-active"));

    item.focus();
    this.activeElement = item;

    this.activeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydown(event) {
    if (this.isOpen() === false && event.key === "Tab") {
      return;
    }

    if (this.isOpen() && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      if (this.activeElement && this.activeElement.tagName === "LI") {
        const item = this.activeElement;
        this.close();
        this.selectItem(item);
      }
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.activeElement = this.trigger;
      this.open();
      return;
    }

    let offset = 0;

    if (event.key === "ArrowDown") {
      offset = 1;
    } else if (event.key === "ArrowUp") {
      offset = -1;
    } else if (event.key === "Tab" && event.shiftKey) {
      offset = -1;
    } else if (event.key === "Tab") {
      offset = 1;
    } else {
      return;
    }

    event.preventDefault();

    const items = this.getVisibleItems();
    let nextItem = null;

    for (let i = 0; i < items.length; i++) {
      if (this.activeElement == items[i]) {
        nextItem = items[i + offset] || null;
        break;
      }
    }

    if (nextItem) {
      this.selectItemFromKeyboard(nextItem);
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleDocumentKeyDown(event) {
    if (event.key === "Escape" || event.key === "esc") {
      this.closeAll();
      return;
    }
  }

  handleClickOutsideEvent() {
    this.close();
  }

  isOpen() {
    return this.container.classList.contains("is-open");
  }

  closeAll() {
    document
      .querySelectorAll("flavor-widget")
      // @ts-ignore
      .forEach((/** @type {FlavorWidget} */ el) => {
        el.close();
      });
  }

  setFlavorImages() {
    if (!this.selectedItem) {
      return;
    }

    const img = this.selectedItem.querySelector("img");
    const flavor = this.getAttribute("value") || "";
    const flavorImage = this.getFlavorIcon(flavor);

    if (!img) {
      return;
    }

    if (flavorImage) {
      img.src = flavorImage;
      img.alt = flavor + " selected icon";
    }

    this.querySelectorAll(".variant-selector__ui-content-item").forEach(
      (el) => {
        if (el instanceof HTMLElement) {
          const img = el.querySelector("img");
          const flavor = el.dataset.value || "";
          const flavorImage = this.getFlavorIcon(flavor);
          if (img && flavorImage) {
            img.src = flavorImage;
          }
        }
      }
    );
  }

  /**
   * @param {string} flavor
   * @returns {string | null}
   * */
  getFlavorIcon(flavor) {
    const basicFlavor = getFlavorNameWithoutSize(flavor);

    if ("PRODUCT_FLAVOR_IMAGES" in window) {
      // @ts-ignore
      return window.PRODUCT_FLAVOR_IMAGES[basicFlavor] || null;
    }
    return null;
  }

  /**
   * @param {string} title
   */
  selectItemByTitle(title) {
    const items = this.querySelectorAll(".variant-selector__ui-content-item");

    for (const item of items) {
      if (item instanceof HTMLElement) {
        if (item.dataset.value === title) {
          this.selectItem(item);
          break;
        }
      }
    }
  }

  /**
   * @param {HTMLElement} item
   */
  selectItem(item) {
    /** @type {NodeListOf<HTMLElement>} */
    const items = this.querySelectorAll(".flavor-widget__item");
    const flavor = item.dataset.value || "";
    const shortName = item.dataset.shortName || flavor;
    const needsTrigger = flavor !== this.getAttribute("value");

    items.forEach((el) => {
      if (el.dataset.value === flavor) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });

    this.setAttribute("value", flavor);

    const selectedEl = this.querySelector(".variant-selector__ui-selected");
    const title = selectedEl?.querySelector("[data-title]");
    const image = selectedEl?.querySelector("img");
    const itemImage = item.querySelector("img");

    // @ts-ignore
    title.innerHTML = shortName.replace(
      " + Caffeine",
      '<span class="is-caffeine">+ caffeine</span>'
    );

    // Only flavor products use the image feature
    if (itemImage && image) {
      // @ts-ignore
      image.src = itemImage.src;
      // @ts-ignore
      image.alt = itemImage.alt;
    }

    if (needsTrigger) {
      const event = new CustomEvent("change", { detail: flavor });
      this.dispatchEvent(event);
    }
  }
}

customElements.define("flavor-widget", FlavorWidget);

class CustomerPoints extends HTMLElement {
  constructor() {
    super();
    this.customer = null;

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.redeemButton = this.querySelector(".cart-points__redeem-btn");

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.historyButton = this.querySelector(".cart-points__history-btn");

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.removeRewardButton = this.querySelector(
      ".cart-points__remove-reward-btn"
    );

    /** @type {HTMLButtonElement} */
    // @ts-ignore
    this.rewardSelect = this.querySelector("reward-select");

    /** @type {import('./points-history.js').PointsHistory} */
    // @ts-ignore
    this.pointsHistory = this.querySelector("points-history");

    this.handleRedeemClick = this.handleRedeemClick.bind(this);
    this.handleHistoryClick = this.handleHistoryClick.bind(this);
    this.handleRewardChange = this.handleRewardChange.bind(this);
    this.handlRemoveRewardClick = this.handlRemoveRewardClick.bind(this);
  }

  connectedCallback() {
    ensureSwellLoaded().then(() => {
      this.customer = window.swellAPI.getCustomerDetails();
      this.renderPoints();
    });

    this.redeemButton.addEventListener("click", this.handleRedeemClick);
    this.historyButton.addEventListener("click", this.handleHistoryClick);

    // @ts-ignore
    this.rewardSelect.addEventListener("change", this.handleRewardChange);

    this.removeRewardButton.addEventListener(
      "click",
      this.handlRemoveRewardClick
    );

    // This can be triggered by the history popup
    this.addEventListener("show-rewards", this.handleRedeemClick);

    this.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  handleHistoryClick() {
    if (this.customer) {
      this.pointsHistory.setAttribute("open", "");
    }
  }

  handleRedeemClick() {
    if (this.customer) {
      this.rewardSelect.setAttribute("open", "");
    }
  }

  handlRemoveRewardClick() {
    removeSelectedReward();
    this.showActiveReward();
  }

  /**
   * @param {CustomEvent} e
   */
  handleRewardChange(e) {
    saveSelectedReward(e.detail.rewardId, e.detail.rewardText);
    this.showActiveReward();
  }

  renderPoints() {
    this.redeemButton.disabled = false;
    this.historyButton.disabled = false;
    this.removeRewardButton.disabled = false;

    // @ts-ignore
    this.querySelector(".cart-points__value").textContent =
      this.customer.pointsBalance;

    this.showActiveReward();
  }

  showActiveReward() {
    const reward = getSelectedReward();

    if (reward) {
      this.removeRewardButton.style.display = "block";
      this.removeRewardButton.textContent = `${reward.rewardText} (remove)`;
    } else {
      this.removeRewardButton.style.display = "none";
    }
  }
}

customElements.define("customer-points", CustomerPoints);

class PointsHistory extends HTMLElement {
  constructor() {
    super();
    this.handleCloseBtnClick = this.handleCloseBtnClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll("button[data-close]").forEach((btn) => {
      if (btn instanceof HTMLButtonElement) {
        btn.addEventListener("click", this.handleCloseBtnClick);
      }
    });
  }

  static get observedAttributes() {
    return ["open"];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open" && oldValue !== newValue) {
      if (newValue === null) {
        this.close();
        return;
      }
      this.open();
    }
  }

  /**
   * @param {MouseEvent} e
   */
  handleCloseBtnClick(e) {
    e.stopPropagation();
    this.close();
    if (
      e.target instanceof HTMLElement &&
      e.target.dataset.close === "show-rewards"
    ) {
      this.dispatchEvent(new Event("show-rewards", { bubbles: true }));
    }
  }

  open() {
    this.renderHistoryItems();
  }

  close() {
    this.removeAttribute("open");
  }

  renderHistoryItems() {
    /** @type {HTMLElement} */
    // @ts-ignore
    const itemsContainer = this.querySelector(".points-history__items");
    const customer = window.swellAPI.getCustomerDetails();
    const historyItems = customer.actionHistoryItems;

    const stub = document.createElement("div");

    // @ts-ignore
    const itemTemplate = this.querySelector(
      "#pointHistoryItemTemplate"
    ).innerHTML;

    let pointsRedeemed = 0;
    let pointsBalance = 0;

    for (const item of historyItems) {
      const data = {
        date: item.date.replaceAll("-", "/"),
        text:
          item.action + (item.status !== "Approved" ? ` (${item.status})` : ""),
        points: pluralize(item.points, "Point", "Points"),
      };

      if (item.status !== "Refunded" && item.points < 0) {
        pointsRedeemed += Math.abs(item.points);
      }

      if (item.status === "Refunded" || item.status === "Approved") {
        pointsBalance += item.points;
      }

      const row = placeholders(itemTemplate, data);
      stub.insertAdjacentHTML("beforeend", row);
    }

    const redeemedText = pluralize(pointsRedeemed, "Point", "Points");
    const earnedText = pluralize(customer.pointsEarned, "Point", "Points");
    const balanceText = pluralize(customer.pointsBalance, "Point", "Points");

    itemsContainer.replaceChildren(...stub.children);

    // @ts-ignore
    this.querySelector(".points-history__footer-redeemed-points").textContent =
      redeemedText;

    // @ts-ignore
    this.querySelector(".points-history__footer-earned-points").textContent =
      earnedText;

    // @ts-ignore
    this.querySelector(".points-history__footer-balance-points").textContent =
      balanceText;
  }
}

customElements.define("points-history", PointsHistory);
